import React, { useEffect, useMemo, useRef, useState } from "react";
import { debounce } from "lodash";
import {
  Button,
  makeStyles,
  Grid,
  MenuItem,
  TextField,
  InputAdornment,
  Tooltip,
  IconButton,
  Typography,
  Box,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
  Dialog,
  DialogContent,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  CircularProgress,
} from "@material-ui/core";
import {
  fetchPurchaseOrdersDashboardFilters,
  fetchPurchaseOrdersNew,
  fetchPurchaseOrdersForQuickSummary,
  fetchQuickSummaryOnly,
} from "../../../containers/actions/common/purchaseOrderAction";
import { useHistory, useLocation } from "react-router-dom";
import MarkPOForDeleteModal from "./MarkPOForDeleteModal";
import AllocatePOsModal from "./AllocatePOsModal";
import moment from "moment";
import { Clear, Refresh } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../helpers/previousProps";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";
import {
  DESTROY_BACKDROP,
  FETCH_PURCHASE_ORDER_LOADING,
  OPEN_BACKDROP,
} from "../../../containers/actions/types";
import jwtDecode from "jwt-decode";
import { cmoMembersList } from "../../../containers/actions/pharmaCo/purchaseOrderActions";
import PaginationInput from "../models/pagination/PaginationInput";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import ClearIcon from "@material-ui/icons/Clear";
import DoneIcon from "@material-ui/icons/Done";
import Block from "./QuickSummary/Block";
import clsx from "clsx";
import { Autocomplete } from "@material-ui/lab";
import StyledButton from "../../../../common/models/Button";
import BackDropLoading from "../models/BackDrop";
import StyledDialog from "../../../../common/models/Dialog";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import { ChevronLeft, ChevronRight, CloudDownload } from '@material-ui/icons';
import { fetchUserAssociation, fetchFGStatus, clearSLFromPODashboard } from "../../../containers/actions/common/purchaseOrderAction";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import PurchaseOrderTabTable from "./PurchaseOrderTabTable";
import { saveDashboardFilters } from "../../../containers/utils/filterUtils";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const useStyles = makeStyles((theme) => ({
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #000000de",
    borderRadius: "0.5rem",
    padding: "0.3rem",
    width: "20px",
    height: "20px",
    textTransform: "none",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "black",
      color: "white",
      border: "1px solid #000000de",
    },
  },
  logoHeight: {
    height: "inherit",
  },
  upload: {
    background:
      "transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;",
    color: "white",
    textTransform: "none",
    borderRadius: "2rem",
    // marginRight: 20,
    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
    },
  },
  stylebutton: {
    borderRadius: "2rem",
    whiteSpace: "nowrap",
    cursor: "pointer",
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#000000",
      color: "#fff",
      textTransform: "none",
    },
  },
  outlineButton: {
    borderRadius: "2rem",
    whiteSpace: "nowrap",
    cursor: "pointer",
    borderColor: "black",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#000000",
      color: "#fff",
      textTransform: "none",
    },
  },
  blueButton: {
    backgroundImage: "linear-gradient(to right, #301232, #1A2D6C,#173072)",
    color: "white",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    paddingLeft: "2.8rem",
    paddingRight: "2.8rem",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
      border: "1px solid green",
    },
  },
  clearText: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: "#173072",
      textDecoration: "underline",
    },
  },
  dpFlx: { display: "flex" },
  algnCntr: { alignItems: "center" },
  pointer: { cursor: "pointer" },
  onHvrUndrline: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
  BtnSty: {
    backgroundColor: "transparent",
    color: "black",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid black",
    },
  },
  inputBaseRoot: {
    padding: "0px",
    paddingRight: "14px",
    height: "40px",
  },
  dialogPaper: {
    padding: theme.spacing(3),
    minWidth: 500,
    borderRadius: 10,
  },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  saveButton: {
    backgroundColor: "#ff5722",
    color: "#fff",
    textTransform: "none",
    fontWeight: "bold",
    padding: "3px 30px",
    borderRadius: "14px",
    "&:hover": {
      backgroundColor: "#e64a19",
    },
  },
  cancelButton: {
    textTransform: "none",
    fontWeight: "bold",
    marginRight: "auto", // Aligns left
  },
  formGroup: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(1),
  },
  saveButtonContainer: {
    display: "flex",
    justifyContent: "center", // Centers the button
    width: "100%",
    paddingBottom: theme.spacing(2),
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },
  accordionSummary: {
    "&.Mui-expanded": {
      minHeight: "50px",
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "10px 0px",
    },
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  deleteDialogTitle: {
    fontWeight: 700,
    fontSize: "22px",
    marginBottom: "1.5rem",
    textAlign: "center",
    color: "#000",
  },
  deleteCloseText: {
    fontSize: "1rem",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: "#FF0000",
  },
  mdWrap: {
    padding: 24,
    position: "relative",
  },
  mdCloseText: {
    fontSize: "1rem",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: "#000", // black
  },
  mdFieldTitle: {
    width: 600,
    maxWidth: "100%",
    margin: "0 auto 8px",
    textAlign: "center",
    marginBottom: "24px",
    fontSize: "17px",
  },
  mdTitle: {
    fontWeight: 700,
    fontSize: 22,
    textAlign: "center",
    color: "#000",
    marginBottom: "1.5rem",
  },
  mdIntro: { textAlign: "left", marginBottom: 24 },
  mdFieldWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 22,
  },
  mdField: {
    width: 600,
    maxWidth: "100%",
  },
  mdDenseControl: {
    "& .MuiOutlinedInput-root": {
      height: 40,
      display: "flex",
      alignItems: "center",
    },
    "& .MuiOutlinedInput-input": { padding: "8px 0px" },
    "& .MuiAutocomplete-input": { padding: "8px 0px !important" },
    "& .MuiAutocomplete-inputRoot": { paddingTop: 0, paddingBottom: 0 },
    '& .MuiSelect-select': {
      paddingLeft: 5,
    },
  },
  mdComment: {
    "& .MuiOutlinedInput-root": {
      "& textarea.MuiInputBase-input": {
        // padding: "8px 12px",
        lineHeight: "20px",
      },
    },
  },
  mdNote: {
    fontSize: 12,
    color: "#666",
    fontStyle: "italic",
    marginTop: 0,
    width: 600,
    maxWidth: "100%",
    textAlign: "left",
  },
  mdCtaRow: { display: "flex", justifyContent: "center", marginTop: 24, marginBottom: 24 },
  mdPrimaryBtn: {
    backgroundColor: "#ec6535",
    color: "#fff",
    borderRadius: "20px",
    textTransform: "none",
    padding: "6px 20px",
    "&:hover": { backgroundColor: "#d4572e" },
  },
  btnDelete: {
    background: "linear-gradient(82deg, #3B173F 0%, #073270 100%)",
    color: "#ffffff",
    borderRadius: "2rem",
    textTransform: "none",
    fontWeight: "500",
    padding: "8px 16px",
    whiteSpace: "nowrap",
    boxShadow: "none",
    transition: "background 0.3s ease-in-out",
    "&:hover": {
      background: "linear-gradient(82deg, #d32f2f 0%, #d32f2f 100%)",
    },
  },
  customButton: {
    background: "linear-gradient(to right, #121C48, #3C0936)",
    color: "#fff",
    borderRadius: "20px",
    padding: "8px 16px",
    textTransform: "none",
    fontWeight: "500",
    boxShadow: "0px 4px 6px rgba(9, 9, 9, 0.1)",
    "&:hover": {
      background: "linear-gradient(to right, #3C0936, #121C48)",
    },
  },
}));

const actionsList = [
  "View all PO",
  "View PO with changes proposed by me",
  "View PO with date != original date",
  "View PO with changes within tolerance limit",
  "View PO with pending review for qty/date change",
  "View PO where allocation approval is required by SRM",
  // BCM-972 (doc, "New Filter in the List of Actions"): filters to POs where the
  // (earliest, if multiple) allocated batch's expiry date is before the Planned
  // MFG Start Date; POs with no allocated batch or no Planned MFG Start Date are excluded.
  "View PO where Bulk Allocation Expiration Date < Planned MFG Start Date",
  "View PO within 45 days, with pending allocation",
  "View PO with qty. variance and batch mismatch (batch consumption)",
  "View PO with expected qty. shortfalls",
  "View PO with delay less than 1 month",
  "View PO with delay between 1 to 2 months",
  "View PO with delay more than 3 months",
  "View PO with ABO/Priority = Low",
  "View PO with ABO/Priority = Medium",
  "View PO with ABO/Priority = High",
  "View PO with EU importation sampling = Yes",
  "View PO with stability req sampling = Yes",
  "View PO with artwork required = Yes (New)",
  "View PO with artwork required = No (Current)",
  "View delayed PO with PO-Level Reason Code / Description pending",
  "View PO with pending cancellation requests"
];

const PurchaseOrderDashboard = (props) => {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [expanded, setExpanded] = useState(false);
  const [selectedAction, setSelectedAction] = useState("View all PO");
  const [quickSummaryFilter, setQuickSummaryFilter] = useState(null);
  const [isNewPOsSelected, setIsNewPOsSelected] = useState(false);
  const { savedFilter } = props;
  const tokenData = useMemo(() => jwtDecode(localStorage.getItem("authToken")), []);
  // BCM-737: poNumber/tab from the Daily PO Update email's "View PO" deep link
  // (?poNumber=...&tab=batchAllocation). Left in the URL for as long as the
  // user stays on this page - the route is component={PcmpAuth(...)}, an inline
  // HOC call producing a new component type on every CmoRoutes render, so any
  // route change remounts this dashboard and the URL is the only state that
  // survives. PurchaseOrderTabTable reads the same query string to expand the
  // row and select the Batch Allocation tab.
  const [deepLinkPoNumber] = useState(
    () => new URLSearchParams(location.search).get("poNumber")
  );
  // Seeded directly into initial state so the very first fetch is already
  // scoped to the deep-linked PO - no second dispatch, nothing to race, and
  // it re-derives identically on every remount.
  const [searchField, setSearchField] = useState(
    deepLinkPoNumber ? "PO Number" : "all"
  );
  const [searchValue, setSearchValue] = useState(deepLinkPoNumber || "");
  const [selectedMarkets, setSelectedMarkets] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [filterByDate, setFilterByDates] = useState(
    savedFilter?.dateOfCreation ? savedFilter?.dateOfCreation : "0"
  );
  const [tokenVendorMosymphonyID, setTokenVendorMosymphonyID] = useState(
    tokenData?.organization_id ? tokenData.organization_id : null
  );
  const [selectedCMOs, setSelectedCMOs] = useState([]);
  const [scheduleAgreementStatusID, setScheduleAgreementStatusID] =
    useState("0");

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [fetchPurchaseOrderData, setFetchPurchaseOrderData] = useState([]);
  const [poStatusArray, setPOStatusArray] = useState([]);
  const [selectedPOStatuses, setSelectedPOStatuses] = useState([]);
  const [allReceivingPlants, setAllReceivingPlants] = useState([]);
  const [plantList, setPlantList] = useState([]);
  const [plannerList, setPlannerList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [mfgPlantList, setMFGPlantList] = useState([])
  const [originalMfgPlantList, setOriginalMFGPlantList] = useState([])
  const [selectedPlantIdList, setSelectedPlantIdList] = useState(
    savedFilter?.plantListFilter && Array.isArray(savedFilter?.plantListFilter)
      ? savedFilter?.plantListFilter
      : []
  );
  const [selectedMFGPlantList, setSelectedMFGPlantList] = useState(
    savedFilter?.mgfPlantListFilter && Array.isArray(savedFilter?.mgfPlantListFilter)
      ? savedFilter?.mgfPlantListFilter
      : []
  );

  const [SelectedCMOList, setSelectedCMOList] = useState([]);
  const [selectedPlannerList, setSelectedPlannerList] = useState(
    savedFilter?.plannerUserId && Array.isArray(savedFilter?.plannerUserId)
      ? savedFilter?.plannerUserId
      : []
  );
  const [selectedBrandList, setSelectedBrandList] = useState(
    savedFilter?.brand && Array.isArray(savedFilter?.brand)
      ? savedFilter?.brand
      : []
  );
  const [productTypeList, setProductTypeList] = useState([]);
  const [selectedProductTypeList, setSelectedProductTypeList] = useState(
    savedFilter?.productType && Array.isArray(savedFilter?.productType)
      ? savedFilter?.productType
      : []
  );
  const [filteredPlantList, setFilteredPlantList] = useState(
    savedFilter?.plantListFilter && Array.isArray(savedFilter?.plantListFilter)
      ? savedFilter?.plantListFilter
      : []
  );
  const [filteredVendorMosymphonyIDList, setFilteredVendorMosymphonyIDList] =
    useState([]);
  const [savedSuccessfull, setSavedSuccessfull] = useState(false);
  const [saveFailed, setSaveFailed] = useState(false);
  const [plannerOptions, setPlannerOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [selectedPO, setSelectedPO] = useState(null);

  let previousVendorList = useRef([]);
  let previousPlantList = useRef([]);
  let previousPlannerList = useRef([]);
  let previousBrandList = useRef([]);
  let previousMfgPlantList = useRef([]);
  let previousProductTypeList = useRef([]);
  const isQuickSummaryActionRef = useRef(false);

  const [supplyTypes, setSupplyTypes] = useState([]);
  const [drugTypes, setDrugTypes] = useState([]);
  const [plantTypes, setPlantTypes] = useState([]);
  const [facilityTypes, setFacilityTypes] = useState([]);
  const [displayMarketValues, setDisplayMarketValues] = useState([]);
  const [displayRegionValues, setDisplayRegionValues] = useState([]);

  // Original types from API to keep as reference
  const [originalSupplyTypes, setOriginalSupplyTypes] = useState([]);
  const [originalDrugTypes, setOriginalDrugTypes] = useState([]);
  const [originalPlantTypes, setOriginalPlantTypes] = useState([]);
  const [originalFacilityTypes, setOriginalFacilityTypes] = useState([]);
  const [originalMarketValues, setOriginalMarketValues] = useState([]);
  const [originalRegionValues, setOriginalRegionValues] = useState([]);

  // Vendor plants data
  const [vendorPlantsData, setVendorPlantsData] = useState([]);
  const [vendorPlantDetails, setVendorPlantDetails] = useState(null);

  // scrolling behaviour changes
  const HEADER_HEIGHT = 100; // Height of the fixed header
  const TABLE_MAX_HEIGHT = 600; // Maximum table height
  const TABLE_MIN_HEIGHT = 400; // Minimum table height

  const [tableHeight, setTableHeight] = useState(TABLE_MIN_HEIGHT);
  const lastScrollYRef = useRef(0);
  const contentRef = useRef(null);

  // Replace location state with Redux state
  const sideBarOpen = useSelector(
    (state) => state.pcmp.common.uiState.sideBarOpen
  );

  // BCM-435: New Mark PO for Delete modal
  const [markDeleteModalOpen, setMarkDeleteModalOpen] = useState(false);

  const [openMarkDelete, setOpenMarkDelete] = useState(false);
  const [mdPoNumber, setMdPoNumber] = useState("");
  const [mdReasonCode, setMdReasonCode] = useState("");
  const [mdComment, setMdComment] = useState("");
  const [mdReasonOptions, setMdReasonOptions] = useState([]);
  const [mdLoadingReasons, setMdLoadingReasons] = useState(false);
  const [mdGeneralError, setMdGeneralError] = useState("");
  const [mdSubmitting, setMdSubmitting] = useState(false);
  const [mdResultOpen, setMdResultOpen] = useState(false);
  const [mdResultType, setMdResultType] = useState("success"); 
  const [mdResultTitle, setMdResultTitle] = useState("");
  const [mdResultSubtext, setMdResultSubtext] = useState("");
  const [mdResultMessage, setMdResultMessage] = useState("");
  const [openMdCheck, setOpenMdCheck] = useState(false);
  const [mdCheckPo, setMdCheckPo] = useState("");
  const [mdUniquePOs, setMdUniquePOs] = useState([]);
  const [mdLoadingPOs, setMdLoadingPOs] = useState(false);

  // Excel preview dialog state
  const [openExcelPreview, setOpenExcelPreview] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [excelFileURL, setExcelFileURL] = useState(null);
  const [excelFileName, setExcelFileName] = useState('');
  const [excelPage, setExcelPage] = useState(0);
  const [excelLoading, setExcelLoading] = useState(false);
  const [activeSheetIndex, setActiveSheetIndex] = useState(0);
  const [sheetScrollPositions, setSheetScrollPositions] = useState({});
  const tableContainerRef = useRef(null);

  // Allocate POs modal state
  const [openAllocatePOs, setOpenAllocatePOs] = useState(false);

  // Restore scroll position when switching sheets
  useEffect(() => {
    if (tableContainerRef.current && sheetScrollPositions[activeSheetIndex]) {
      tableContainerRef.current.scrollTop = sheetScrollPositions[activeSheetIndex].scrollTop || 0;
      tableContainerRef.current.scrollLeft = sheetScrollPositions[activeSheetIndex].scrollLeft || 0;
    }
  }, [activeSheetIndex, excelData, sheetScrollPositions]);

  const openMarkDeleteDialog = () => {
    setMdCheckPo("");
    setMdPoNumber("");
    setMdReasonCode("");
    setMdComment("");
    // setMdPoError("");
    setMdGeneralError("");
    setOpenMdCheck(true);
  };

  const closeMdCheckDialog = () => {
    setOpenMdCheck(false);
    setMdCheckPo("");
  };

  const fetchMdUniquePOs = async () => {
    setMdLoadingPOs(true);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchUniquePO`;
      const res = await axios.get(url, {});
      setMdUniquePOs(Array.isArray(res?.data?.data) ? res.data.data : []);
    } catch (e) {
      setMdUniquePOs([]);
    } finally {
      setMdLoadingPOs(false);
    }
  };

  useEffect(() => {
    if (openMdCheck) fetchMdUniquePOs();
  }, [openMdCheck]);

  const getMdPoDetails = (poNo) => {
    const d = (mdUniquePOs || []).find(
      (r) => r?.scheduleAgreementNumber === poNo
    ) || {};
    return {
      cmo: d?.vendorName || "",
      cmoId: String(d?.vendorNumber ?? ""),
      productCode: d?.fgMaterialCode || "",
      productDesc: d?.fgMaterialName || "",
      qty: d?.targetQuantity ?? "",
      uom: d?.targetQuantityUOM || "",
      date: d?.deliveryDate
        ? (() => {
          const date = new Date(d.deliveryDate);
          const day = date.getDate().toString().padStart(2, '0');
          const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
            'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
          const month = monthNames[date.getMonth()];
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        })()
        : "N/A",
      vendorMosymphonyId: d?.vendorMosymphonyId || null,
    };
  };

  const openMarkDeleteDialogFromCheck = () => {
    setOpenMdCheck(false);
    setMdPoNumber(mdCheckPo || "");
    setOpenMarkDelete(true);
    fetchMdReasonCodes();
  };

  const closeMarkDeleteDialog = () => {
    setOpenMarkDelete(false);
    setMdPoNumber("");
    setMdReasonCode("");
    setMdComment("");
    setMdGeneralError("");
  };

  const fetchMdReasonCodes = async () => {
    setMdLoadingReasons(true);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodesDirect`;
      const requestObject = {
        searchField: "all",
        searchValue: "",
        reasonCodeGroupType: "all",
        reasonCodeType: "all",
        status: "all",
        collaboratorTypeID: "all",
      };
      const res = await axios.post(url, requestObject);
      const list = res?.data?.data?.reasonCodeList || [];
      setMdReasonOptions(list);
    } catch (e) {
      console.error("Reason code fetch failed", e);
      setMdReasonOptions([]);
    } finally {
      setMdLoadingReasons(false);
    }
  };

  const handleConfirmMarkDelete = async () => {
    const po = (mdPoNumber || "").trim();
    const reason = (mdReasonCode || "").trim();
    const cmt = (mdComment || "").trim();

    let hasError = false;
    if (!reason && !cmt) {
      setMdGeneralError("If reason code is not entered, comment field is mandatory");
      hasError = true;
    } else {
      setMdGeneralError("");
    }
    if (hasError) return;

    setMdSubmitting(true);

    try {
      const selectedPODetails = (mdUniquePOs || []).find(
        (r) => r?.scheduleAgreementNumber === po
      );

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/deletePOFromUI`;
      const payload = {
        scheduleAgreementNumber: po,
        reasonCode: reason || null,
        comments: cmt || null,
        vendorMosymphonyID: selectedPODetails.vendorMosymphonyId || null,
      };
      const res = await axios.post(url, payload);
      const data = res?.data || {};
      closeMarkDeleteDialog();

      // CASE 1: SUCCESS
      const isSuccess =
        (data?.status === true || data?.success === true || data?.cordaResponse?.status === true) &&
        (data?.statusCode === 200 || data?.cordaResponse?.statusCode === 200);

      if (isSuccess) {
        setMdResultType("success");
        setMdResultTitle(`PO Number ${po} marked\nfor deletion successfully`);
        setMdResultSubtext("");
      }
      // CASE 2: ERROR
      else {
        setMdResultType("error");
        setMdResultTitle("PO Deletion Failed");
        setMdResultMessage(data?.errorMessage || data?.message || "Something went wrong. Please try again.");
      }
      setMdResultOpen(true);
    }
    // CASE 3: NETWORK ERROR
    catch (e) {
      closeMarkDeleteDialog();
      setMdResultType("error");
      setMdResultTitle("Network Error");
      setMdResultMessage("Something went wrong. Please try again.");
      setMdResultOpen(true);
    } finally {
      setMdSubmitting(false);
    }
  };

  const handleUploadPOs = () => {
    sessionStorage.clear();
    history.push({
      pathname: "uploadPOs",
    });
  };

  const handleDownloadData = async () => {
    try {
      setExcelLoading(true);
      dispatch({ type: OPEN_BACKDROP });

      const payload = {
        vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
        plantCodeList: selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
        plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
        brand: selectedBrandList.length > 0 ? selectedBrandList : [],
        collaboratorTypeID: tokenData.collaborator_type_id,
        aslNumberList: selectedMFGPlantList,
        productTypeIDs: selectedProductTypeList.length > 0 ? selectedProductTypeList : [],
        deliveryNotCompletePOs: true,
      };


      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadPurchaseOrdersExcel`,
        payload,
        {
          responseType: "blob",
          headers: {
            "X-User-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone
          }
        }
      );

      // Check if response is JSON error message instead of Excel blob
      const contentType = response.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        const text = await response.data.text();
        const jsonResponse = JSON.parse(text);

        if (!jsonResponse.status) {
          // Show error dialog with the actual message from API
          setMdResultType("error");
          setMdResultTitle("No Data Available");
          setMdResultMessage(jsonResponse.message || "No purchase order records found");
          setMdResultOpen(true);
          dispatch({ type: DESTROY_BACKDROP });
          setExcelLoading(false);
          return;
        }
      }

      // Create blob and URL for download
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      setExcelFileURL(url);

      // Set filename
      const fileName = `PO_Data_${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;
      setExcelFileName(fileName);

      // Parse Excel data for preview
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const XLSX = await import('xlsx');
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // Parse all sheets
          const allSheets = workbook.SheetNames.map((sheetName) => {
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            return {
              name: sheetName,
              data: jsonData
            };
          });

          setExcelData(allSheets[0]?.data || []);
          setActiveSheetIndex(0);
          setExcelPage(0);
          setOpenExcelPreview(true);
        };
        reader.readAsArrayBuffer(blob);
      } catch (error) {
        console.error('Error parsing Excel:', error);
        // If parsing fails, just download the file directly
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

      dispatch({ type: DESTROY_BACKDROP });
    } catch (err) {
      dispatch({ type: DESTROY_BACKDROP });
      console.error("Error downloading data:", err);

      // Check if error response contains JSON with specific message
      if (err.response && err.response.data) {
        try {
          let errorData = err.response.data;

          // If data is a Blob, try to parse it as JSON
          if (errorData instanceof Blob) {
            const text = await errorData.text();
            errorData = JSON.parse(text);
          }

          if (errorData.status === false && errorData.message) {
            setMdResultType("error");
            setMdResultTitle("No Data Available");
            setMdResultMessage(errorData.message);
            setMdResultOpen(true);
            setExcelLoading(false);
            return;
          }
        } catch (parseErr) {
          console.error("Error parsing error response:", parseErr);
        }
      }

      // Default error message if no specific message found
      setMdResultType("error");
      setMdResultTitle("Download Failed");
      setMdResultMessage("An error occurred while downloading data. Please try again.");
      setMdResultOpen(true);
    } finally {
      setExcelLoading(false);
    }
  };

  const handleCloseExcelPreview = () => {
    setOpenExcelPreview(false);
    if (excelFileURL) {
      URL.revokeObjectURL(excelFileURL);
      setExcelFileURL(null);
    }
    setExcelData(null);
    setActiveSheetIndex(0);
    setExcelPage(0);
    setSheetScrollPositions({});
  };

  // Group rows by PO Number (first column)
  const groupRowsByPO = (rows) => {
    const grouped = [];
    let currentGroup = null;

    rows.forEach((row, index) => {
      const poNumber = row[0]; // First column is PO Number

      if (poNumber && poNumber !== '') {
        // This is a parent row (has PO Number)
        if (currentGroup) {
          grouped.push(currentGroup);
        }
        currentGroup = {
          parentRow: row,
          subRows: [],
          originalIndex: index,
          poNumber: poNumber
        };
      } else if (currentGroup) {
        // This is a sub-row (empty PO Number)
        currentGroup.subRows.push({ row, originalIndex: index });
      }
    });

    // Add the last group
    if (currentGroup) {
      grouped.push(currentGroup);
    }

    return grouped;
  };

  const uniqueBrandOptions = Array.isArray(brandList)
    ? brandList.map((item) =>
      typeof item === "string" ? { brand: item } : item
    )
    : [];

  useEffect(() => {
    const handleScroll = () => {
      if (!contentRef.current) return;

      const scrollY = window.scrollY;
      const isScrollingDown = scrollY > lastScrollYRef.current;
      lastScrollYRef.current = scrollY;

      const contentTop = contentRef.current.getBoundingClientRect().top;
      const availableHeight = window.innerHeight - HEADER_HEIGHT;

      let newHeight = availableHeight - Math.max(contentTop, 0);
      newHeight = Math.min(
        Math.max(newHeight, TABLE_MIN_HEIGHT),
        TABLE_MAX_HEIGHT
      );

      if (isScrollingDown) {
        // Expand table height when scrolling down
        setTableHeight(newHeight);
      } else {
        // Shrink table height when scrolling up
        setTableHeight(TABLE_MIN_HEIGHT);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  // scrolling behaviour changes

  useEffect(() => {
    if (sideBarOpen) {
      setExpanded(false); // close the accordion when sidebar is open
    }
  }, [sideBarOpen]);

  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess.data
        .poCollaborationDashboard
  );

  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess.poCollaborationDashboard
  );

  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess)
      dispatch(
        getFeaturesAccess(screenAccess?.screenId, "poCollaborationDashboard")
      );
  }, [dispatch, screenAccess, featuresAccess]);

  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );
  const userAssociationData = useSelector(
    (state) => state.pcmp?.common?.purchaseOrder?.userAssociationResult || null
  );

  const purchaseOrderData = useSelector((state) =>
    state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsNew
      ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsNew
      : {}
  );

  const poQuickSummary = useSelector((state) =>
    state.pcmp.common?.purchaseOrder?.poQuickSummaryNew
      ? state.pcmp.common?.purchaseOrder?.poQuickSummaryNew?.data
        ?.POQuickSummary
      : {}
  );


  let poQuickSummaryLoading = useSelector(
    (state) => state.pcmp.common?.purchaseOrder?.poQuickSummaryLoading
  );

  let prevPurchaseOrderData = usePrevious(purchaseOrderData);

  const previousFilters = useRef(null);
  const purchaseOrderSourceRef = useRef(null);

  const debouncedFetchPurchaseOrdersRef = useRef(
    debounce((filters, dispatchFn) => {
      if (purchaseOrderSourceRef.current) {
        purchaseOrderSourceRef.current.cancel("Previous request cancelled");
      }

      const CancelToken = axios.CancelToken;
      purchaseOrderSourceRef.current = CancelToken.source();

      dispatchFn({
        type: FETCH_PURCHASE_ORDER_LOADING,
        payload: true,
      });

      const finalPayload = {
        ...filters,
        cancelToken: purchaseOrderSourceRef.current.token,
      };

      dispatchFn(fetchPurchaseOrdersNew(finalPayload, undefined))
        .then(() => { })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            console.error("Error in fetchPurchaseOrdersNew:", error);
          }
        });
    }, 500)
  );

  useEffect(() => {

    // Skip if critical data is missing
    if (!tokenData.collaborator_type_id || !savedFilter) {
      // console.log("Skipping API call due to missing tokenData or savedFilter");
      return;
    }

    // Skip if quick summary action is in progress
    if (isQuickSummaryActionRef.current) {
      return;
    }

    // BCM-737: while the active search is still the deep-linked PO itself,
    // don't merge in the user's saved (broader) dashboard filters - sending a
    // PO-scoped search AND a broad brand/plant filter in the same request
    // resolves to the broad list and clobbers the single-PO view. Once the
    // user changes the search, saved filters apply normally again.
    const isDeepLinkSearchActive =
      deepLinkPoNumber && searchField === "PO Number" && searchValue === deepLinkPoNumber;

    const currentFilters = {
      searchField,
      searchValue,
      noOfDaysAgo: parseInt(filterByDate),
      collaboratorTypeID: tokenData.collaborator_type_id,
      scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
      scheduleLineStatusIDList: isNewPOsSelected ? [21, 22] : null,
      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
      plantCodeList: isDeepLinkSearchActive || !Array.isArray(savedFilter?.plantListFilter)
        ? []
        : savedFilter?.plantListFilter,
      vendorMosymphonyIDList: isDeepLinkSearchActive || !Array.isArray(savedFilter?.cmoListFilter)
        ? []
        : savedFilter?.cmoListFilter,
      pageNumber: currentPage,
      pageSize: rowsPerPage,
      plannerSaasUserIDs: [],
      brand: isDeepLinkSearchActive || !Array.isArray(savedFilter?.brand) ? [] : savedFilter?.brand,
      aslNumberList: isDeepLinkSearchActive || !Array.isArray(savedFilter?.mfgPlantList) ? [] : savedFilter?.mfgPlantList,
      productTypeIDs: isDeepLinkSearchActive || !Array.isArray(savedFilter?.productType) ? [] : savedFilter?.productType
    };

    if (
      previousFilters.current &&
      JSON.stringify(previousFilters.current) === JSON.stringify(currentFilters)
    ) {
      return;
    }

    previousFilters.current = currentFilters;

    const plantList = Array.isArray(savedFilter?.plantListFilter)
      ? savedFilter?.plantListFilter
      : [];
    const cmoList = Array.isArray(savedFilter?.cmoListFilter)
      ? savedFilter?.cmoListFilter
      : [];
    const plannerList = Array.isArray(savedFilter?.plannerUserId)
      ? savedFilter?.plannerUserId
      : [];
    const dateFilter = savedFilter?.dateOfCreation
      ? savedFilter?.dateOfCreation
      : "0";
    const brandList = Array.isArray(savedFilter?.brand)
      ? savedFilter?.brand
      : [];
    const mfgPlantList = Array.isArray(savedFilter?.mfgPlantList)
      ? savedFilter?.mfgPlantList
      : [];

    if (JSON.stringify(selectedPlantIdList) !== JSON.stringify(plantList)) {
      setSelectedPlantIdList(plantList);
    }
    if (JSON.stringify(SelectedCMOList) !== JSON.stringify(cmoList)) {
      setSelectedCMOList(cmoList);
    }
    if (JSON.stringify(selectedPlannerList) !== JSON.stringify(plannerList)) {
      setSelectedPlannerList(plannerList);
    }
    if (JSON.stringify(selectedBrandList) !== JSON.stringify(brandList)) {
      setSelectedBrandList(brandList);
    }
    if (filterByDate !== dateFilter) {
      setFilterByDates(dateFilter);
    }
    if (JSON.stringify(filteredPlantList) !== JSON.stringify(plantList)) {
      setFilteredPlantList(plantList);
    }
    if (
      JSON.stringify(filteredVendorMosymphonyIDList) !== JSON.stringify(cmoList)
    ) {
      setFilteredVendorMosymphonyIDList(cmoList);
    }

    if (
      JSON.stringify(previousVendorList.current) !== JSON.stringify(cmoList)
    ) {
      previousVendorList.current = cmoList;
    }
    if (
      JSON.stringify(previousPlantList.current) !== JSON.stringify(plantList)
    ) {
      previousPlantList.current = plantList;
    }
    if (
      JSON.stringify(previousPlannerList.current) !==
      JSON.stringify(plannerList)
    ) {
      previousPlannerList.current = plannerList;
    }
    if (
      JSON.stringify(previousBrandList.current) !== JSON.stringify(brandList)
    ) {
      previousBrandList.current = brandList;
    }

    if (
      JSON.stringify(previousMfgPlantList.current) !== JSON.stringify(mfgPlantList)
    ) {
      previousMfgPlantList.current = mfgPlantList;
    }
    debouncedFetchPurchaseOrdersRef.current(currentFilters, dispatch);

    return () => {
      if (purchaseOrderSourceRef.current) {
        purchaseOrderSourceRef.current.cancel("Component unmounted");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    savedFilter,
    filterByDate,
    tokenData.collaborator_type_id,
    scheduleAgreementStatusID,
    // selectedAction, // Removed: handleFilterAction already handles API call when action changes

    dispatch,
    // selectedPlantIdList,
    // SelectedCMOList,
    // selectedPlannerList,
    // selectedBrandList,
    // filteredPlantList,
    // filteredVendorMosymphonyIDList,
  ]);

  useEffect(() => {

    let { collabType, ecosystemId, organizationName, roleName } = localStorage;
    if (collabType !== "CMO") {
      dispatch(
        cmoMembersList({
          collabType: collabType,
          roleName: roleName,
          organizationName: organizationName,
          ecosystemId: ecosystemId,
        })
      );
    }

    const baseUrl = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}`;
    // CQRS Phase 1+2a: reference dropdowns moved to direct-PG endpoints (suffix `Direct`).
    Promise.all([
      axios.get(`${baseUrl}/fetchPlantSupplyTypesDirect/true`),
      axios.get(`${baseUrl}/fetchPlantDrugTypesDirect/true`),
      axios.get(`${baseUrl}/fetchPlantTypesDirect/true`),
      axios.get(`${baseUrl}/fetchMarketValues`),
      axios.get(`${baseUrl}/fetchRegionCodes`),
      axios.get(`${baseUrl}/fetchFacilityTypesDirect/true`),
      axios.get(`${baseUrl}/fetchAllVendorPlantsDirect`),
    ])
      .then(([supplyRes, drugRes, plantRes, marketRes, regionRes, facilityRes, vendorPlantsRes]) => {
        if (supplyRes.data?.data?.status) {
          const supplyTypeList = supplyRes.data?.data?.supplyTypeList ?? [];
          setSupplyTypes(supplyTypeList);
          setOriginalSupplyTypes(supplyTypeList);
        }
        if (drugRes.data?.data?.status) {
          const drugTypeList = drugRes.data?.data?.drugTypeList ?? [];
          setDrugTypes(drugTypeList);
          setOriginalDrugTypes(drugTypeList);
        }
        if (plantRes.data?.data?.status) {
          const plantTypeList = plantRes.data?.data?.plantTypeList ?? [];
          setPlantTypes(plantTypeList);
          setOriginalPlantTypes(plantTypeList);
        }
        if (marketRes.data?.status) {
          const marketList = marketRes.data?.data
            ? marketRes.data.data.map((item) => ({
              market_group: item.market_group,
              marketorder_be: item.marketorder_be,
              count_items: item.count_items,
            }))
            : [];
          setDisplayMarketValues(marketList);
          setOriginalMarketValues(marketList);
        }
        if (regionRes.data?.status) {
          const regionList = regionRes.data?.RegionCodes
            ? regionRes.data.RegionCodes.map((regionCode) => ({ regionCode }))
            : [];
          setDisplayRegionValues(regionList);
          setOriginalRegionValues(regionList);
        }
        if (facilityRes.data?.data?.status) {
          const facilityTypesList = facilityRes.data?.data?.facilityTypesList ?? [];
          setFacilityTypes(facilityTypesList);
          setOriginalFacilityTypes(facilityTypesList);
        }
        if (vendorPlantsRes.data?.status) {
          setVendorPlantsData(vendorPlantsRes.data?.vendorPlantDetails || []);
        }
      })
      .catch((err) => {
        console.error("Error fetching filter options:", err);
      });


    let isMounted = true;

    // Fetch all receiving plant IDs and storage location IDs with vendorMosymphonyID = 'all'
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllReceivingPlantIDsAndStorageLocationIDsDirect/all`
      )
      .then((res) => {
        if (isMounted && res.data?.vendorOrgLevelData) {
          // Flatten receivingPlantIDs from all vendorOrgLevelData objects and remove duplicates
          const formattedPlants = res.data.vendorOrgLevelData.flatMap((item) =>
            (item.receivingPlantIDs || [])
              .filter((id) => id)
              .map((id) => ({
                plantCode: id,
                vendorMosymphonyID: item.vendorMosymphonyID,
                supplyTypeName:
                  supplyTypes.find((st) => st.supplyTypeID === id)?.supplyTypeName || "",
                drugTypeName:
                  drugTypes.find((dt) => dt.drugTypeID === id)?.drugTypeName || "",
                plantTypeName:
                  plantTypes.find((pt) => pt.plantTypeID === id)?.plantTypeName || "",
                facilityTypeName:
                  facilityTypes.find((ft) => ft.facilityTypeID === id)?.facilityTypeName || ""
              }))
          );

          // Group plants by plantCode and collect all vendorMosymphonyIDs for each plant
          const plantGroups = formattedPlants.reduce((acc, plant) => {
            if (!acc[plant.plantCode]) {
              acc[plant.plantCode] = {
                plantCode: plant.plantCode,
                vendorMosymphonyIDs: [],
                supplyTypeName: plant.supplyTypeName,
                drugTypeName: plant.drugTypeName,
                plantTypeName: plant.plantTypeName,
                facilityTypeName: plant.facilityTypeName
              };
            }
            if (!acc[plant.plantCode].vendorMosymphonyIDs.includes(plant.vendorMosymphonyID)) {
              acc[plant.plantCode].vendorMosymphonyIDs.push(plant.vendorMosymphonyID);
            }
            return acc;
          }, {});

          // Converting to array format, keeping the first vendorMosymphonyID as primary for each plant
          const uniquePlants = Object.values(plantGroups).map(plant => ({
            plantCode: plant.plantCode,
            vendorMosymphonyID: plant.vendorMosymphonyIDs[0],
            allVendorMosymphonyIDs: plant.vendorMosymphonyIDs,
            supplyTypeName: plant.supplyTypeName,
            drugTypeName: plant.drugTypeName,
            plantTypeName: plant.plantTypeName,
            facilityTypeName: plant.facilityTypeName
          }));

          setAllReceivingPlants(uniquePlants);
          setPlantList(uniquePlants);
          // setPlantIdOptions(uniquePlants);
        } else if (isMounted) {
          setAllReceivingPlants([]);
          setPlantList([]);
          // setPlantIdOptions([]);
        }
      })
      .catch((err) => {
        if (isMounted) {
          console.error(
            "Error fetching receiving plant IDs and storage locations for vendorMosymphonyID = 'all':",
            err
          );
          setAllReceivingPlants([]);
          setPlantList([]);
          // setPlantIdOptions([]);
        }
      });
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBrandValues`
      )
      .then((res) => {
        if (res.data?.status) {
          const brands = res.data?.data ? res.data?.data : [];
          setBrandList(brands);
          setBrandOptions(brands);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchProductTypes/false`
      )
      .then((res) => {
        if (res.data?.status) {
          const productTypes = res.data?.data?.productTypeList ? res.data?.data?.productTypeList : [];
          setProductTypeList(productTypes);
        }
      })
      .catch((err) => {
        console.error("Error fetching product types:", err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchMfgPlants`
      )
      .then((res) => {
        if (res.data?.status) {
          const plants = res.data?.MfgPlantsDetails ? res.data?.MfgPlantsDetails : [];
          setMFGPlantList(plants);
          setOriginalMFGPlantList(plants)
        }
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlannerDetailsDirect`)
      .then((res) => {
        if (res.data?.status) {
          //console.log("res is here",res)
          setPlannerOptions(res.data?.data ? res.data?.data : []);
          setPlannerList(res.data?.data ? res.data?.data : []);
          //setBrandList(res.data?.data ? res.data?.data : []);
          // setBrandOptions(res.data?.data ? res.data?.data : []); // Removed this line
        }
      })
      .catch((err) => {
        console.error(err);
      });

    // Call fetchVendorPlantDetails API (skip when caller has no vendor org context — sponsor-side users)
    if (tokenVendorMosymphonyID) {
      axios
        .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchVendorPlantDetailsDirect/${tokenVendorMosymphonyID}`)
        .then((res) => {
          if (res.data?.data?.vendorPlantDetails) {
            setVendorPlantDetails(res.data.data.vendorPlantDetails);
          }
        })
        .catch((err) => {
          console.error("Error calling fetchVendorPlantDetails API:", err);
        });
    }


    // Existing code for fetching other data...

    return () => {
      isMounted = false; // Cleanup to prevent memory leaks
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      JSON.stringify(purchaseOrderData) !==
      JSON.stringify(prevPurchaseOrderData)
    ) {
      if (purchaseOrderData?.poDetailsList) {
        const poDataWithStaticBatchNumbers = {
          ...purchaseOrderData,
          poDetailsList: purchaseOrderData.poDetailsList.map((poItem, index) => ({
            ...poItem,
            batchDetails: poItem.batchDetails && Object.keys(poItem.batchDetails).length > 0 ? {
              ...poItem.batchDetails,
              vendorBatchNumber: poItem.batchDetails.vendorBatchNumber,
            } : poItem.batchDetails
          }))
        };
        setFetchPurchaseOrderData(poDataWithStaticBatchNumbers);
      } else {
        setFetchPurchaseOrderData(purchaseOrderData);
      }
    }
  }, [purchaseOrderData, prevPurchaseOrderData]);

  let showPagination = fetchPurchaseOrderData?.totalNoOfRecords > 0; // Always show if the data is fetched


  const tokenn = localStorage.getItem("authToken");
  useEffect(() => {
    if (tokenn) {
      try {
        const payload = jwtDecode(tokenn);
        const userId = payload.saas_user_id;

        // Dispatch fetchUserAssociation with the decoded userId
        dispatch(fetchUserAssociation(userId))
          .catch((error) => {
            console.error("Error fetching user associations:", error);
          });
      } catch (e) {
        console.error("Invalid token", e);
      }
    }
  }, [tokenn, dispatch]);


  let fetchPurchaseOrderDataLoading = useSelector(
    (state) => state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsLoading
  );

  useEffect(() => {
    if (!fetchPurchaseOrderDataLoading && isQuickSummaryActionRef.current) {
      isQuickSummaryActionRef.current = false;
    }
  }, [fetchPurchaseOrderDataLoading]);

  const handleClearFilters = async () => {

    setSelectedPO(null);
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Clearing filters...",
    });

    try {
      // BCM-737: drop poNumber/tab from the URL once the user explicitly
      // clears the search - the deep-link state is seeded from location.search
      // on mount, so leaving them in the URL would re-apply this same filter
      // on the next hard refresh even though the user just cleared it.
      if (deepLinkPoNumber) {
        const params = new URLSearchParams(location.search);
        params.delete("poNumber");
        params.delete("tab");
        const newSearch = params.toString();
        console.log("[deepLink] cleared - removing poNumber/tab from URL");
        history.replace({
          pathname: location.pathname,
          search: newSearch ? `?${newSearch}` : "",
        });
      }

      // Reset all previous filter references
      resetPreviousFilters();

      // Reset all selection states
      resetSelectionStates();

      // Reset filtered dropdown lists to show ALL available options
      resetFilteredLists();

      // Reset type filters to show all types
      resetTypeFilters();

      // Reset search trigger state
      // resetSearchTriggerState();

      // Reset search select value state
      // resetSearchSelectValueState();

      // Reset vendor Mosymphony ID state
      resetVendorMosymphonyIDState();

      // Reset schedule agreement status ID state
      resetScheduleAgreementStatusIDState();

      // Reset filter by dates state
      resetFilterByDatesState();

      // Reset current page state
      resetCurrentPageState();

      // Reset search field and value states
      resetSearchFieldAndValueStates();

      // Reset selected action state
      resetSelectedActionState();

      // Reset selected PO state
      resetSelectedPOState();

      // Reset quick summary filter state
      resetQuickSummaryFilterState();

      // Reset table height state
      resetTableHeightState();
      setSelectedBrandList([]);
      setSelectedCMOList([]);
      setSelectedCMOs([]);
      setFilteredVendorMosymphonyIDList([]);
      setSelectedPlantIdList([]);
      setFilteredPlantList([]);
      setSelectedPlannerList([]);
      setSelectedMarkets([]);
      setSelectedRegions([]);
      setSelectedMFGPlantList([]);
      setSelectedProductTypeList([]);

      // Ensure planner list shows all available planners after clearing
      setPlannerList(plannerOptions);

      dispatch({
        type: DESTROY_BACKDROP,
      });

      // Make API call with cleared filters
      makeClearedFiltersAPICall();
    } catch (err) {
      console.error("Error clearing filters:", err);
      dispatch({
        type: DESTROY_BACKDROP,
      });
    }
  };


  const handleRefresh = () => {
    setSelectedPO(null);

    // Clear all SL props data before refreshing to ensure fresh fetch
    dispatch(clearSLFromPODashboard());


    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrdersNew({
        searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
        searchValue: searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" ? searchValue : null,
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
        scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
        viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
        plantCodeList: filteredPlantList,
        vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: selectedPlannerList,
        brand: selectedBrandList,
        aslNumberList: selectedMFGPlantList,
        productTypeIDs: selectedProductTypeList,
        poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
        marketValues: marketValuesForAPI,
        regionCodes: regionCodesForAPI,
      }, 'withoutQuickSummary')
    );
  };

  // Refresh only the quick summary without closing rows or updating table data
  const handleQuickSummaryRefresh = () => {
    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    // Call ONLY the quick summary API, doesn't update table data
    dispatch(
      fetchQuickSummaryOnly({
        searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
        searchValue: searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" ? searchValue : null,
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
        scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
        viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
        plantCodeList: filteredPlantList,
        vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: selectedPlannerList,
        brand: selectedBrandList,
        aslNumberList: selectedMFGPlantList,
        productTypeIDs: selectedProductTypeList,
        poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
        marketValues: marketValuesForAPI,
        regionCodes: regionCodesForAPI,
      })
    );
  };

  const handleClearSearch = () => {
    //console.log('handleClearSearch called for field:', searchField);
    if (searchField === "Market") {
      setSearchValue("");
      setSelectedMarkets([]);
    } else if (searchField === "Region") {
      setSearchValue("");
      setSelectedRegions([]);
    } else if (searchField === "PO Status") {
      setSelectedPOStatuses([]);
      setSearchValue([]);
    } else if (searchField === "Date of PO Creation") {
      setSearchValue("");
      setFilterByDates("0");
    } else {
      setSearchValue("");
    }
    setSearchField("all");
    setSelectedPO(null);

    setCurrentPage(1); //Reset to first page

    // Make API call to refresh PO details without quick summary when clearing search
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrdersNew({
        searchField: "all",
        searchValue: null,
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
        scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
        viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
        plantCodeList: selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
        vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: selectedPlannerList,
        brand: selectedBrandList,
        aslNumberList: selectedMFGPlantList,
        productTypeIDs: selectedProductTypeList,
        poStatusIDList: null,
        regionCodes: null,
      }, 'withoutQuickSummary')
    );
  };

  const validateSearchValue = (value) => {
    const trimmedValue = value.trim();

    if (searchField === "PO Number") {
      // Allow only numbers
      const regex = /^[0-9]+$/;
      return regex.test(trimmedValue); // Returns true if valid
    } else if (searchField === "Product Code") {
      // Allow numbers and hyphens
      const regex = /^[0-9-]+$/; // Match one or more digits and hyphens
      return regex.test(trimmedValue); // Returns true if valid
    } else if (searchField === "Product description") {
      const regex = /^[A-Za-z0-9. ]+$/;
      return regex.test(trimmedValue);
      // return true;
    } else if (searchField === "BMS Component / Material Code") {
      // Allow free text
      return true;
    } else if (searchField === "BMS Component / Material Description") {
      // Allow free text
      return true;
    } else if (searchField === "Allocated BMS Component / Material Batch Number") {
      // Allow free text
      return true;
    }

    return true; // Default to valid if no condition matches
  };

  const handleSearchField = (event) => {
    setSelectedPO(null);
    // Reset search value and selected value when changing search field
    const newSearchField = event.target.value;
    setSearchField(newSearchField);

    // Set appropriate initial value based on search field type
    if (newSearchField === "PO Status") {
      setSearchValue([]); // Initialize as empty array for PO Status
      setSelectedPOStatuses([]);
    } else if (newSearchField === "Market") {
      setSearchValue([]); // Initialize as empty array for Market
      setSelectedMarkets([]);
    } else if (newSearchField === "Region") {
      setSearchValue([]); // Initialize as empty array for Region
      setSelectedRegions([]);
    } else if (newSearchField === "Date of PO Creation") {
      setSearchValue(null); // Initialize as null for date field
    } else {
      setSearchValue(""); // Initialize as empty string for other fields
    }

  };

  const handleSearchValue = (event) => {
    setSelectedPO(null);
    const newValue = event.target.value;
    if (validateSearchValue(newValue, searchField) || newValue === "") {
      setSearchValue(newValue);
    }
  };


  // Separate function to handle quick summary API calls without interfering with main filter logic
  const executeQuickSummaryAPICall = (val, type) => {
    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    dispatch(
      fetchPurchaseOrdersForQuickSummary({
        searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
        searchValue: searchField !== "all" && searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" && searchField !== "Date of PO Creation" ? searchValue : (searchField === "Date of PO Creation" && searchValue ? moment(searchValue).format("YYYY-MM-DD") : null),
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        scheduleLineStatusID:
          type !== "PO_Action" ? parseInt(val) : parseInt(0),
        scheduleLineStatusIDList: (type === "status" && val === 22) ? [21, 22] : null,
        viewPOOption:
          type === "PO_Action"
            ? val === "View all PO"
              ? "all"
              : val
            : val === 22
              ? "all"
              : selectedAction === "View all PO"
                ? "all"
                : selectedAction,
        plantCodeList: selectedPlantIdList,
        vendorMosymphonyIDList: SelectedCMOList,
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: selectedPlannerList,
        brand: selectedBrandList,
        aslNumberList: selectedMFGPlantList,
        poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
        marketValues: marketValuesForAPI,
        regionCodes: regionCodesForAPI,
      })
    );
  };

  const executeCleanQuickSummaryAPICall = () => {
    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    dispatch(
      fetchPurchaseOrdersForQuickSummary({
        searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
        searchValue: searchField !== "all" && searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" && searchField !== "Date of PO Creation" ? searchValue : (searchField === "Date of PO Creation" && searchValue ? moment(searchValue).format("YYYY-MM-DD") : null),
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        scheduleLineStatusID: 0,
        scheduleLineStatusIDList: null,
        viewPOOption: "all",
        plantCodeList: selectedPlantIdList,
        vendorMosymphonyIDList: SelectedCMOList,
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: selectedPlannerList,
        brand: selectedBrandList,
        aslNumberList: selectedMFGPlantList,
        productTypeIDs: selectedProductTypeList,
        poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
        marketValues: marketValuesForAPI,
        regionCodes: regionCodesForAPI,
      })
    );
  };

  const handleQuickStatus = (val, type) => {
    // Set ref flag to prevent main useEffect from interfering
    isQuickSummaryActionRef.current = true;

    if (type !== "PO_Action") {
      setScheduleAgreementStatusID(val);
    } else {
      setScheduleAgreementStatusID(0);
    }

    // Set flag to track if "New POs" is specifically selected
    setIsNewPOsSelected(type === "status" && val === 22);

    setQuickSummaryFilter(val);
    setSelectedPO(null);
    setSelectedAction(val);
    setCurrentPage(1); //Reset to first page

    // Use separate API call that preserves current filter selections
    executeQuickSummaryAPICall(val, type);
  };

  const handleCleanQuickSummary = () => {
    // Set ref flag to prevent main useEffect from interfering
    isQuickSummaryActionRef.current = true;

    setSelectedPO(null);
    setScheduleAgreementStatusID("0");
    setQuickSummaryFilter(null);
    setSelectedAction("View all PO");
    setIsNewPOsSelected(false);
    setCurrentPage(1); //Reset to first page

    // Use separate API call that preserves current filter selections
    executeCleanQuickSummaryAPICall();
  };

  const handleSearchClick = () => {
    setSelectedPO(null);

    // Prepare market values for API - extract marketorder_be arrays from selected markets
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      // Flatten all marketorder_be arrays from selected markets into a single array
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    setCurrentPage(1); //Reset to first page
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrdersNew({
        searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
        searchValue: searchField !== "all" && searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" && searchField !== "Date of PO Creation" ? searchValue.trim() : (searchField === "Date of PO Creation" && searchValue ? moment(searchValue).format("YYYY-MM-DD") : null),
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
        scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
        viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
        plantCodeList: selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
        aslNumberList: selectedMFGPlantList,

        vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: selectedPlannerList,
        brand: selectedBrandList,
        productTypeIDs: selectedProductTypeList,
        poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
        marketValues: marketValuesForAPI,
        regionCodes: regionCodesForAPI,
      }, 'withoutQuickSummary') // Don't call quick summary for search
    );
  };



  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = event.target.value;
    setRowsPerPage(newRowsPerPage);

    setCurrentPage(1); //Reset to first page

    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrdersNew({
        searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
        searchValue: searchField !== "all" && searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" && searchField !== "Date of PO Creation" ? searchValue : (searchField === "Date of PO Creation" && searchValue ? moment(searchValue).format("YYYY-MM-DD") : null),
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        //vendorMosymphonyID: parseInt(vendorMosymphonyID),
        scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
        scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
        viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
        plantCodeList: filteredPlantList,
        aslNumberList: selectedMFGPlantList,
        vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
        pageNumber: 1,
        pageSize: newRowsPerPage,
        plannerSaasUserIDs: selectedPlannerList,
        brand: selectedBrandList,
        productTypeIDs: selectedProductTypeList,
        poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
        marketValues: marketValuesForAPI,
        regionCodes: regionCodesForAPI,
      }, 'withoutQuickSummary')
    );
  };

  const handlePageChange = (newPage) => {
    setSelectedPO(null);
    setCurrentPage(newPage);

    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    const paginationApiPayload = {
      searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
      searchValue: searchField !== "all" && searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" && searchField !== "Date of PO Creation" ? searchValue : (searchField === "Date of PO Creation" && searchValue ? moment(searchValue).format("YYYY-MM-DD") : null),
      noOfDaysAgo: parseInt(filterByDate),
      collaboratorTypeID: tokenData.collaborator_type_id,
      //vendorMosymphonyID: parseInt(vendorMosymphonyID),
      scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
      scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
      plantCodeList: selectedPlantIdList,
      vendorMosymphonyIDList: SelectedCMOList,
      pageNumber: newPage,
      pageSize: rowsPerPage,
      plannerSaasUserIDs: selectedPlannerList,
      brand: selectedBrandList,
      aslNumberList: selectedMFGPlantList,
      productTypeIDs: selectedProductTypeList,
      poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
      marketValues: marketValuesForAPI,
      regionCodes: regionCodesForAPI,
    };

    dispatch(
      fetchPurchaseOrdersNew(paginationApiPayload, 'withoutQuickSummary')
    );
  };

  const handleUpdateRefresh = (type) => {
    // Only reset to page 1 if it's NOT a simple data refresh (withoutQuickSummary)
    // For withoutQuickSummary, maintain the current page so changes on page 2+ display properly
    if (type !== "withoutQuickSummary") {
      setCurrentPage(1);
    }

    if (type === "updatedPONegotiation") {
      setQuickSummaryFilter(null);
      setScheduleAgreementStatusID("0");
      setSelectedAction("View all PO");
    }

    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    // Clear all SL props data before refreshing to ensure fresh fetch
    dispatch(clearSLFromPODashboard());
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    // Determine page number for API call
    // Special case: For "View delayed POs" with data update, fetch page 1 and reset currentPage state
    let pageNumberForAPI = 1; // Default for most cases
    let shouldResetPage = false;

    if (type === "withoutQuickSummary") {
      // Check if this is the "View delayed POs" action
      if (selectedAction === "View delayed POs with PO-level Reason Code / Description pending") {
        pageNumberForAPI = 1;
        shouldResetPage = true;
      } else {
        // For other withoutQuickSummary cases, maintain current page
        pageNumberForAPI = currentPage;
      }
    }

    dispatch(
      fetchPurchaseOrdersNew(
        {
          searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
          searchValue: searchField !== "all" && searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" && searchField !== "Date of PO Creation" ? searchValue : (searchField === "Date of PO Creation" && searchValue ? moment(searchValue).format("YYYY-MM-DD") : null),
          noOfDaysAgo: parseInt(filterByDate),
          collaboratorTypeID: tokenData.collaborator_type_id,
          scheduleLineStatusID:
            type === "updatedPONegotiation"
              ? 0
              : parseInt(scheduleAgreementStatusID),
          scheduleLineStatusIDList:
            type === "updatedPONegotiation"
              ? null
              : null,
          viewPOOption:
            type === "updatedPONegotiation"
              ? "all"
              : selectedAction === "View all PO"
                ? "all"
                : selectedAction,
          plantCodeList: filteredPlantList,
          vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
          pageNumber: pageNumberForAPI,
          pageSize: rowsPerPage,
          plannerSaasUserIDs: selectedPlannerList,
          brand: selectedBrandList,
          aslNumberList: selectedMFGPlantList,
          productTypeIDs: selectedProductTypeList,
          poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
          marketValues: marketValuesForAPI,
          regionCodes: regionCodesForAPI,
        },
        type === "withoutQuickSummary" ? "withoutQuickSummary" : type
      )
    ).then(() => {
      // Reset currentPage state if needed for "View delayed POs" action
      if (shouldResetPage) {
        setCurrentPage(1);
      }
    });
  };
  const handleFilterAction = (value) => {
    setSelectedAction(value);
    setCurrentPage(1);
    setSelectedPO(null);
    setQuickSummaryFilter(value);
    setIsNewPOsSelected(false); // Reset the New POs flag when using List of actions

    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });
    dispatch(
      fetchPurchaseOrdersNew({
        searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
        searchValue: searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" ? searchValue : null,
        noOfDaysAgo: parseInt(filterByDate),
        collaboratorTypeID: tokenData.collaborator_type_id,
        scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
        scheduleLineStatusIDList: null,
        viewPOOption: value === "View all PO" || value === null ? "all" : value,
        plantCodeList: filteredPlantList,
        vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: selectedPlannerList,
        aslNumberList: selectedMFGPlantList,
        brand: selectedBrandList,
        productTypeIDs: selectedProductTypeList,
        poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
        marketValues: marketValuesForAPI,
        regionCodes: regionCodesForAPI,
      }, 'withoutQuickSummary') 
    );
  };


  const handleChangeCMOList = (event) => {
    const value = event.target.value;
    setSelectedPO(null);

    let newCMOList = [];
    let filteredPlants = [];
    let filteredMfgPlants = [];

    if (value.includes("All")) {
      const availableCMOs = getAvailableCMOs();

      newCMOList =
        SelectedCMOList.length === availableCMOs.length
          ? []
          : availableCMOs.map((val) => val.organization_id);
      filteredPlants = allReceivingPlants.filter((val) =>
        newCMOList.length === 0 ||
        newCMOList.some(cmoId =>
          val.allVendorMosymphonyIDs ?
            val.allVendorMosymphonyIDs.includes(cmoId) :
            val.vendorMosymphonyID === cmoId
        )
      );
      filteredMfgPlants = originalMfgPlantList
    } else {
      newCMOList = value;
      // When no CMOs are selected, show all plants; otherwise filter by selected CMOs
      filteredPlants = value.length === 0
        ? allReceivingPlants
        : allReceivingPlants.filter((val) =>
          value.some(cmoId =>
            val.allVendorMosymphonyIDs ?
              val.allVendorMosymphonyIDs.includes(cmoId) :
              val.vendorMosymphonyID === cmoId
          )
        );

      filteredMfgPlants = value.length === 0 ? originalMfgPlantList : originalMfgPlantList.filter((val) =>
        value.some(cmoId => val.vendorMosymphonyID === cmoId
        ))
    }

    setSelectedCMOList(newCMOList);
    setFilteredVendorMosymphonyIDList(newCMOList);
    setSelectedCMOs(newCMOList);
    setPlantList(filteredPlants);
    // setPlantIdOptions(filteredPlants);
    setMFGPlantList(filteredMfgPlants)

    // Filter planners based on selected CMOs (but don't auto-select them)
    setPlannerList(
      newCMOList.length > 0
        ? plannerOptions.filter(
          (planner) =>
            planner.organization_ids &&
            planner.organization_ids.some((orgId) => newCMOList.includes(orgId))
        )
        : plannerOptions
    );
    // Update selected plants to only include those associated with the new CMO list
    if (selectedPlantIdList.length > 0) {
      setSelectedPlantIdList(
        selectedPlantIdList.filter((plantCode) =>
          filteredPlants.some((plant) => plant.plantCode === plantCode)
        )
      );
      setFilteredPlantList(
        selectedPlantIdList.filter((plantCode) =>
          filteredPlants.some((plant) => plant.plantCode === plantCode)
        )
      );
    } else {
      setSelectedPlantIdList([]);
      setFilteredPlantList([]);
    }

    // Update type filters
    filterTypesBySelectedCMO(newCMOList);


  };

  const getDisplayCMOFilterValue = () => {
    const availableCMOs = getAvailableCMOs();

    if (
      SelectedCMOList.length === availableCMOs.length &&
      SelectedCMOList.length !== 1
    ) {
      return "All";
    } else if (
      SelectedCMOList.length === availableCMOs.length &&
      SelectedCMOList.length === 1
    ) {
      let result = availableCMOs.filter(
        (val) => SelectedCMOList[0] === val.organization_id
      );
      if (result.length > 0) {
        return result[0].organization_name;
      } else {
        return "All";
      }
    } else if (SelectedCMOList.length === 1) {
      let result = availableCMOs.filter(
        (val) => SelectedCMOList[0] === val.organization_id
      );
      if (result.length > 0) {
        return result[0].organization_name;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };

  const handleChangePlantIdList = (event) => {
    const value = event.target.value;
    setSelectedPO(null);

    if (value.includes("All")) {
      setSelectedPlantIdList(
        selectedPlantIdList.length === plantList.length
          ? []
          : plantList.map((val) => val.plantCode)
      );

      // If "All" plants are selected, clear filtered CMO list
      // This prevents CMO IDs from being automatically included in API calls
      // unless the user explicitly selects CMOs
      setFilteredVendorMosymphonyIDList([]);

      // Show all available planners when "All" plants are selected
      setPlannerList(plannerOptions);
    } else {
      // previousPlantList.current = value
      setSelectedPlantIdList(value);

      // Filter CMOs and planners based on selected plant IDs
      if (value.length > 0) {
        // Get all vendorMosymphonyIDs from selected plants (including all associated vendors)
        const selectedPlantVendorIds = value.flatMap(plantCode => {
          const plant = allReceivingPlants.find(p => p.plantCode === plantCode);
          return plant ? (plant.allVendorMosymphonyIDs || [plant.vendorMosymphonyID]) : [];
        });

        // Filter CMOs to only show those associated with selected plants
        const availableCMOs = cmoMemberWithId.filter(cmo =>
          selectedPlantVendorIds.includes(cmo.organization_id)
        );

        // IMPORTANT: Clear filteredVendorMosymphonyIDList when plants change
        // This prevents CMO IDs from being automatically included in API calls
        // unless the user explicitly selects CMOs
        setFilteredVendorMosymphonyIDList([]);

        // Filter planners to only show those associated with the CMOs of selected plants
        const availablePlanners = plannerOptions.filter(planner =>
          planner.organization_ids &&
          planner.organization_ids.some(orgId =>
            selectedPlantVendorIds.includes(orgId)
          )
        );

        // Update the planner list to show only available planners
        setPlannerList(availablePlanners);

        // Update CMO selection to only include available CMOs
        if (SelectedCMOList.length > 0) {
          setSelectedCMOList(
            SelectedCMOList.filter(cmoId =>
              availableCMOs.some(cmo => cmo.organization_id === cmoId)
            )
          );
          setSelectedCMOs(
            SelectedCMOList.filter(cmoId =>
              availableCMOs.some(cmo => cmo.organization_id === cmoId)
            )
          );
        }

        // Update planner selection to only include available planners
        if (selectedPlannerList.length > 0) {
          setSelectedPlannerList(
            selectedPlannerList.filter(plannerId =>
              availablePlanners.some(planner => planner.saasUserID === plannerId)
            )
          );
        }
      } else {
        // If no plants selected, clear filtered CMO list
        // This prevents CMO IDs from being automatically included in API calls
        // unless the user explicitly selects CMOs
        setFilteredVendorMosymphonyIDList([]);
        setPlannerList(plannerOptions);
        // Don't clear selected CMOs and planners when no plants are selected
        // This allows users to see all options while maintaining their selections
      }
    }

    // Trigger data fetch to update results
    handleSelectChangeListLosesFocus("plantID", userAssociationData);
  };

  const handleChangeMFGPlantList = (event) => {
    const value = event.target.value;
    setSelectedPO(null);

    if (value.includes("All")) {
      // previousPlantList.current = selectedPlantIdList.length === plantList.length ? [] : plantList.map((val)=> val.plantCode)
      setSelectedMFGPlantList(
        selectedMFGPlantList.length === mfgPlantList.length
          ? []
          : mfgPlantList.map((val) => val.aslNumber)
      );

      // If "All" plants are selected, clear filtered CMO list
      // This prevents CMO IDs from being automatically included in API calls
      // unless the user explicitly selects CMOs
      setFilteredVendorMosymphonyIDList([]);

      // Show all available planners when "All" plants are selected
      setPlannerList(plannerOptions);
    } else {
      // previousPlantList.current = value
      setSelectedMFGPlantList(value);

      // Filter CMOs and planners based on selected plant IDs
      if (value.length > 0) {
        // Get all vendorMosymphonyIDs from selected plants (including all associated vendors)
        const selectedPlantVendorIds = value.flatMap(aslNumber => {
          const plant = mfgPlantList.find(p => p.aslNumber === aslNumber);
          return plant ? [plant.vendorMosymphonyID] : [];
        });

        // Filter CMOs to only show those associated with selected plants
        const availableCMOs = cmoMemberWithId.filter(cmo =>
          selectedPlantVendorIds.includes(cmo.organization_id)
        );

        // IMPORTANT: Clear filteredVendorMosymphonyIDList when plants change
        // This prevents CMO IDs from being automatically included in API calls
        // unless the user explicitly selects CMOs
        setFilteredVendorMosymphonyIDList([]);

        // Filter planners to only show those associated with the CMOs of selected plants
        const availablePlanners = plannerOptions.filter(planner =>
          planner.organization_ids &&
          planner.organization_ids.some(orgId =>
            selectedPlantVendorIds.includes(orgId)
          )
        );

        // Update the planner list to show only available planners
        setPlannerList(availablePlanners);

        // Update CMO selection to only include available CMOs
        if (SelectedCMOList.length > 0) {
          setSelectedCMOList(
            SelectedCMOList.filter(cmoId =>
              availableCMOs.some(cmo => cmo.organization_id === cmoId)
            )
          );
          setSelectedCMOs(
            SelectedCMOList.filter(cmoId =>
              availableCMOs.some(cmo => cmo.organization_id === cmoId)
            )
          );
        }

        // Update planner selection to only include available planners
        if (selectedPlannerList.length > 0) {
          setSelectedPlannerList(
            selectedPlannerList.filter(plannerId =>
              availablePlanners.some(planner => planner.saasUserID === plannerId)
            )
          );
        }
      } else {
        // If no plants selected, clear filtered CMO list
        // This prevents CMO IDs from being automatically included in API calls
        // unless the user explicitly selects CMOs
        setFilteredVendorMosymphonyIDList([]);
        setPlannerList(plannerOptions);
        // Don't clear selected CMOs and planners when no plants are selected
        // This allows users to see all options while maintaining their selections
      }
    }

    // Trigger data fetch to update results
    handleSelectChangeListLosesFocus("mfgPlants");
  };

  const getDisplayPlantIDValue = () => {
    if (
      selectedPlantIdList.length === plantList.length &&
      selectedPlantIdList.length !== 1
    )
      return "All";
    else if (
      selectedPlantIdList.length === plantList.length &&
      selectedPlantIdList.length === 1
    ) {
      let result = plantList.filter(
        (val) => selectedPlantIdList[0] === val.plantCode
      );
      if (result.length > 0) {
        return result[0].plantCode;
      } else {
        return "All";
      }
    } else if (selectedPlantIdList.length === 1) {
      let result = plantList.filter(
        (val) => selectedPlantIdList[0] === val.plantCode
      );
      if (result.length > 0) {
        return result[0].plantCode;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };


  const handleChangePlannerList = (event) => {
    const selectedPlannerIds = event.target.value;
    setSelectedPO(null);

    let filteredPlants = [];

    if (selectedPlannerIds.includes("All")) {
      setSelectedPlannerList(
        selectedPlannerList.length === plannerList.length
          ? []
          : plannerList.map((val) => val.saasUserID)
      );
      // If "All" is selected, show all plants
      filteredPlants = allReceivingPlants;
    } else {
      setSelectedPlannerList(selectedPlannerIds);

      // Get available CMOs for filtering plants, but DON'T auto-select them
      const selectedPlanners = plannerList.filter((planner) =>
        selectedPlannerIds.includes(planner.saasUserID)
      );

      // If no planners are selected, show all plants; otherwise filter by available CMOs
      if (selectedPlanners.length === 0) {
        filteredPlants = allReceivingPlants;
      } else {
        const availableCMOIds = [
          ...new Set(
            selectedPlanners.flatMap((planner) =>
              planner.organization_ids ? planner.organization_ids : []
            )
          ),
        ];

        // Filter plants based on the available CMO list (check all associated vendor IDs)
        filteredPlants = allReceivingPlants.filter((plant) =>
          availableCMOIds.some(cmoId =>
            plant.allVendorMosymphonyIDs ?
              plant.allVendorMosymphonyIDs.includes(cmoId) :
              plant.vendorMosymphonyID === cmoId
          )
        );
      }
    }

    // Update plant states only - DON'T auto-select CMOs
    setPlantList(filteredPlants);
    // setPlantIdOptions(filteredPlants);

    // Update selected plants to only include those associated with the available CMOs
    if (selectedPlantIdList.length > 0) {
      setSelectedPlantIdList(
        selectedPlantIdList.filter((plantCode) =>
          filteredPlants.some((plant) => plant.plantCode === plantCode)
        )
      );
      setFilteredPlantList(
        selectedPlantIdList.filter((plantCode) =>
          filteredPlants.some((plant) => plant.plantCode === plantCode)
        )
      );
    } else {
      setSelectedPlantIdList([]);
      setFilteredPlantList([]);
    }

    // Update type filters based on available CMOs (but don't auto-select them)
    if (selectedPlannerIds.includes("All")) {
      filterTypesBySelectedCMO(cmoMemberWithId.map(cmo => cmo.organization_id));
    } else {
      const selectedPlanners = plannerList.filter((planner) =>
        selectedPlannerIds.includes(planner.saasUserID)
      );
      const availableCMOIds = [
        ...new Set(
          selectedPlanners.flatMap((planner) =>
            planner.organization_ids ? planner.organization_ids : []
          )
        ),
      ];
      filterTypesBySelectedCMO(availableCMOIds);
    }

    // Clear filteredVendorMosymphonyIDList when planner changes
    // This prevents CMO IDs from being automatically included in API calls
    // unless the user explicitly selects CMOs
    setFilteredVendorMosymphonyIDList([]);

    // Trigger data fetch
    handleSelectChangeListLosesFocus("Planner", userAssociationData);
  };

  const getDisplayPlannerValue = () => {
    if (
      selectedPlannerList.length === plannerList.length &&
      selectedPlannerList.length !== 1
    )
      return "All";
    else if (
      selectedPlannerList.length === plannerList.length &&
      selectedPlannerList.length === 1
    ) {
      let result = plannerList.filter(
        (val) => selectedPlannerList[0] === val.saasUserID
      );
      if (result.length > 0) {
        return result[0].name;
      } else {
        return "All";
      }
    } else if (selectedPlannerList.length === 1) {
      let result = plannerList.filter(
        (val) => selectedPlannerList[0] === val.saasUserID
      );
      if (result.length > 0) {
        return result[0].name;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };

  const getDisplayMFGPlantValue = () => {
    if (
      selectedMFGPlantList.length === mfgPlantList.length &&
      selectedMFGPlantList.length !== 1
    )
      return "All";
    else if (
      selectedMFGPlantList.length === mfgPlantList.length &&
      selectedMFGPlantList.length === 1
    ) {
      let result = mfgPlantList.filter(
        (val) => selectedMFGPlantList[0] === val.aslNumber
      );
      if (result.length > 0) {
        return result[0].mfgPlantShortName;
      } else {
        return "All";
      }
    } else if (selectedMFGPlantList.length === 1) {
      let result = mfgPlantList.filter(
        (val) => selectedMFGPlantList[0] === val.aslNumber
      );
      if (result.length > 0) {
        return result[0].mfgPlantShortName;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };
  const handleChangeBrandList = (event) => {
    const value = event.target.value;
    setSelectedPO(null);

    if (value.includes("All")) {
      // Toggle between selecting all brands and clearing all
      const allBrands = uniqueBrandOptions.map((option) => option.brand);
      setSelectedBrandList(
        selectedBrandList.length === allBrands.length ? [] : allBrands
      );
    } else {
      // Filter out invalid values and "All"
      const filteredValue = value.filter((v) => v !== "All" && v);
      setSelectedBrandList(filteredValue);
    }
  };


  const getDisplayBrandValue = () => {
    if (
      selectedBrandList.length === uniqueBrandOptions.length &&
      selectedBrandList.length !== 1
    ) {
      return "All";
    } else if (selectedBrandList.length === 1) {
      const brand = uniqueBrandOptions.find(
        (option) => option.brand === selectedBrandList[0]
      );
      if (!brand) return "All";
      return brand.brand
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }
    return selectedBrandList.length > 0 ? "Multiple selection" : "All";
  };

  const handleChangeProductTypeList = (event) => {
    const value = event.target.value;
    setSelectedPO(null);

    if (value.includes("All")) {
      // Toggle between selecting all product types and clearing all
      const allProductTypes = productTypeList.map((option) => option.productTypeID);
      setSelectedProductTypeList(
        selectedProductTypeList.length === allProductTypes.length ? [] : allProductTypes
      );
    } else {
      // Filter out invalid values and "All"
      const filteredValue = value.filter((v) => v !== "All" && v);
      setSelectedProductTypeList(filteredValue);
    }
  };

  const getDisplayProductTypeValue = () => {
    if (
      selectedProductTypeList.length === productTypeList.length &&
      selectedProductTypeList.length !== 1
    ) {
      return "All";
    } else if (selectedProductTypeList.length === 1) {
      const productType = productTypeList.find(
        (option) => option.productTypeID === selectedProductTypeList[0]
      );
      if (!productType) return "All";
      return productType.productTypeName;
    }
    return selectedProductTypeList.length > 0 ? "Multiple selection" : "All";
  };

  const handleSelectChangeListLosesFocus = (type, userAssociations) => {
    setSelectedPO(null);
    let filteredCMO;  
    let filteredPlantIds;

    if (type === "cmo") {
      setFilteredVendorMosymphonyIDList(SelectedCMOList);
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds =
        selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else if (type === "plantID") {
      setFilteredPlantList(
        selectedPlantIdList.length > 0 ? selectedPlantIdList : []
      );
      // For plant changes, only include CMOs if explicitly selected
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds =
        selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else if (type === "Planner") {
      // For planner changes, only include CMOs if explicitly selected
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds =
        selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else if (type === "brand") {

      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds =
        selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else if (type === "mfgPlants") {
      filteredCMO = selectedMFGPlantList.flatMap(aslNumber => {
        const plant = mfgPlantList.find(p => p.aslNumber === aslNumber);
        return plant ? [plant.vendorMosymphonyID] : [];
      });

      if(filteredCMO.length !== 0){
        setSelectedCMOList(filteredCMO);
      }
      // SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds =
        selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else if (type === "productType") {
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds =
        selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else {
      // For other types, only include CMOs if explicitly selected
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds =
        selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    }

    // Prepare market values for API - extract marketorder_be arrays from selected markets
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      // Flatten all marketorder_be arrays from selected markets into a single array
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    // Log parameters for debugging
    const requestParams = {
      searchField: searchField === "PO Status" && (!Array.isArray(searchValue) || searchValue.length === 0) ? "all" : (searchField === "Market" && selectedMarkets.length === 0) ? "all" : (searchField === "Region" && selectedRegions.length === 0) ? "all" : searchField,
      searchValue: searchField !== "all" && searchField !== "PO Status" && searchField !== "Market" && searchField !== "Region" && searchField !== "Date of PO Creation" ? searchValue : (searchField === "Date of PO Creation" && searchValue ? moment(searchValue).format("YYYY-MM-DD") : null),
      noOfDaysAgo: parseInt(filterByDate),
      collaboratorTypeID: tokenData.collaborator_type_id,
      scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
      scheduleLineStatusIDList: null,
      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
      plantCodeList: filteredPlantIds,
      vendorMosymphonyIDList: filteredCMO,
      pageNumber: 1,
      pageSize: rowsPerPage,
      plannerSaasUserIDs: selectedPlannerList,
      brand: selectedBrandList,
      aslNumberList: selectedMFGPlantList,
      productTypeIDs: selectedProductTypeList.length > 0 ? selectedProductTypeList : [],
      poStatusIDList: searchField === "PO Status" && Array.isArray(searchValue) && searchValue.length > 0 ? searchValue : null,
      marketValues: marketValuesForAPI,
      regionCodes: regionCodesForAPI,
    };

    if (
      !(
        previousVendorList.current.length === SelectedCMOList.length &&
        JSON.stringify([...previousVendorList.current].sort()) ===
        JSON.stringify([...SelectedCMOList].sort())
      ) ||
      !(
        previousPlantList.current.length === selectedPlantIdList.length &&
        JSON.stringify([...previousPlantList.current].sort()) ===
        JSON.stringify([...selectedPlantIdList].sort())
      ) ||
      !(
        previousPlannerList.current.length === selectedPlannerList.length &&
        JSON.stringify([...previousPlannerList.current].sort()) ===
        JSON.stringify([...selectedPlannerList].sort())
      ) ||
      !(
        previousBrandList.current.length === selectedBrandList.length &&
        JSON.stringify([...previousBrandList.current].sort()) ===
        JSON.stringify([...selectedBrandList].sort())
      ) ||
      !(
        previousMfgPlantList.current.length === selectedMFGPlantList.length &&
        JSON.stringify([...previousMfgPlantList.current].sort()) ===
        JSON.stringify([...selectedMFGPlantList].sort())
      ) ||
      !(
        previousProductTypeList.current.length === selectedProductTypeList.length &&
        JSON.stringify([...previousProductTypeList.current].sort()) ===
        JSON.stringify([...selectedProductTypeList].sort())
      )
    ) {
      previousPlannerList.current = selectedPlannerList;
      previousPlantList.current = selectedPlantIdList;
      previousVendorList.current = SelectedCMOList;
      previousBrandList.current = selectedBrandList;
      previousMfgPlantList.current = selectedMFGPlantList;
      previousProductTypeList.current = selectedProductTypeList;
      setCurrentPage(1);
      dispatch({
        type: FETCH_PURCHASE_ORDER_LOADING,
        payload: true,
      });
      dispatch(fetchPurchaseOrdersNew(requestParams))
        .catch((error) => {
          console.error("fetchPurchaseOrdersNew error:", error);
        });
    }
  };

  const handleSaveFilter = async () => {
    setSelectedPO(null);
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait...",
    });

    const filtersToSave = {
      ...savedFilter,
      cmoListFilter: SelectedCMOList,
      plantListFilter: selectedPlantIdList,
      plannerUserId: selectedPlannerList,
      dateOfCreation: filterByDate,
      brand: selectedBrandList,
      mfgPlantList: selectedMFGPlantList,
      productTypeIDs: selectedProductTypeList,
    };

    try {
      // Use the correct dashboard type "poCollaborationDashboard"
      const result = await saveDashboardFilters(
        "poCollaborationDashboard",
        filtersToSave
      );

      if (result.status) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        setSavedSuccessfull(true);
      } else {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        setSaveFailed(true);
      }
    } catch (err) {
      console.error("Error saving filters:", err);
      dispatch({
        type: DESTROY_BACKDROP,
      });
      setSaveFailed(true);
    }
  };

  const handleCloseSave = () => {
    setSavedSuccessfull(false);
    dispatch(fetchPurchaseOrdersDashboardFilters());
  };
  const handleTableFocusMode = (isFocused) => {
    // When focusing on a single PO, maximize the table height
    setTableHeight(isFocused ? TABLE_MAX_HEIGHT : TABLE_MIN_HEIGHT);
  };

  useEffect(() => {
    dispatch(fetchFGStatus())
      .then((res) => {
        if (res?.status) {
          const statuses = res?.data?.poStatuses || [];

          const filteredStatuses = statuses.filter(
            (status) => status.status_id !== 30
          );
          setPOStatusArray(filteredStatuses);
        }
      })
      .catch((err) => {
        console.error("Error fetching PO statuses:", err);
      });
  }, [dispatch]);


  // Function to get available CMOs based on planner selection
  const getAvailableCMOs = () => {
    let availableCMOs = cmoMemberWithId;

    // Filter by planner selection first
    if (selectedPlannerList.length > 0 && !selectedPlannerList.includes("All")) {
      availableCMOs = availableCMOs.filter((option) => {
        return selectedPlannerList.some(plannerId => {
          const planner = plannerList.find(p => p.saasUserID === plannerId);
          return planner && planner.organization_ids &&
            planner.organization_ids.includes(option.organization_id);
        });
      });
    }

    // Filter by MFG plant selection second
    if (selectedMFGPlantList.length > 0 && !selectedMFGPlantList.includes("All")) {

      const selectedPlantVendorIds = selectedMFGPlantList.flatMap(aslNumber => {
        const plant = mfgPlantList.find(p => p.aslNumber === aslNumber);
        return plant ? [plant.vendorMosymphonyID] : [];
      });

      // Filter CMOs to only show those associated with selected plants
      availableCMOs = availableCMOs.filter(cmo =>
        selectedPlantVendorIds.includes(cmo.organization_id)
      );

    }

    if (selectedMFGPlantList.length > 1 && selectedMFGPlantList.includes("All")) {

      const selectedPlantVendorIds = selectedMFGPlantList.flatMap(aslNumber => {
        const plant = mfgPlantList.find(p => p.aslNumber === aslNumber);
        return plant ? [plant.vendorMosymphonyID] : [];
      });

      // Filter CMOs to only show those associated with selected plants
      availableCMOs = availableCMOs.filter(cmo =>
        selectedPlantVendorIds.includes(cmo.organization_id)
      );

    }

    // Filter by plant selection third
    if (selectedPlantIdList.length > 0 && !selectedPlantIdList.includes("All")) {
      // Get all vendorMosymphonyIDs from selected plants (including all associated vendors)
      const selectedPlantVendorIds = selectedPlantIdList.flatMap(plantCode => {
        const plant = allReceivingPlants.find(p => p.plantCode === plantCode);
        return plant ? (plant.allVendorMosymphonyIDs || [plant.vendorMosymphonyID]) : [];
      });

      // Filter CMOs to only show those associated with selected plants
      availableCMOs = availableCMOs.filter(cmo =>
        selectedPlantVendorIds.includes(cmo.organization_id)
      );
    }

    return availableCMOs;
  };

  // Function to filter types based on selected CMO
  const filterTypesBySelectedCMO = (selectedCMOIds) => {
    // If no CMO selected or "All" is selected, show all types
    if (!selectedCMOIds || selectedCMOIds.length === 0) {
      setSupplyTypes(originalSupplyTypes);
      setDrugTypes(originalDrugTypes);
      setPlantTypes(originalPlantTypes);
      setFacilityTypes(originalFacilityTypes);
      setDisplayMarketValues(originalMarketValues);
      setDisplayRegionValues(originalRegionValues);
      return;
    }

    // Filter vendor plants by selected CMO IDs
    const filteredVendorPlants = vendorPlantsData.filter(plant =>
      selectedCMOIds.includes(plant.vendorMosymphonyID)
    );

    // Extract unique type IDs from filtered vendor plants
    const uniqueSupplyTypeIds = new Set();
    const uniqueDrugTypeIds = new Set();
    const uniquePlantTypeIds = new Set();
    const uniqueFacilityTypeIds = new Set();

    filteredVendorPlants.forEach(plant => {
      // Handle supply types
      if (plant.supplyTypeIDs) {
        plant.supplyTypeIDs.split(',').forEach(id => uniqueSupplyTypeIds.add(parseInt(id)));
      }

      // Handle drug types
      if (plant.drugTypeIDs) {
        plant.drugTypeIDs.split(',').forEach(id => uniqueDrugTypeIds.add(parseInt(id)));
      }

      // Handle plant types
      if (plant.plantTypeIDs) {
        plant.plantTypeIDs.split(',').forEach(id => uniquePlantTypeIds.add(parseInt(id)));
      }

      // Handle facility types
      if (plant.facilityTypeIDs) {
        plant.facilityTypeIDs.split(',').forEach(id => uniqueFacilityTypeIds.add(parseInt(id)));
      }
    });

    // Filter types by extracted IDs
    const filteredSupplyTypes = originalSupplyTypes.filter(type =>
      uniqueSupplyTypeIds.has(type.supplyTypeID)
    );

    const filteredDrugTypes = originalDrugTypes.filter(type =>
      uniqueDrugTypeIds.has(type.drugTypeID)
    );

    const filteredPlantTypes = originalPlantTypes.filter(type =>
      uniquePlantTypeIds.has(type.plantTypeID)
    );

    const filteredFacilityTypes = originalFacilityTypes.filter(type =>
      uniqueFacilityTypeIds.has(type.facilityTypeID)
    );

    // Update state with filtered types
    setSupplyTypes(filteredSupplyTypes);
    setDrugTypes(filteredDrugTypes);
    setPlantTypes(filteredPlantTypes);
    setFacilityTypes(filteredFacilityTypes);
    setDisplayMarketValues(originalMarketValues);
    setDisplayRegionValues(originalRegionValues);
  };

  // Function to reset all type filters to show all types
  const resetTypeFilters = () => {
    setSupplyTypes(originalSupplyTypes);
    setDrugTypes(originalDrugTypes);
    setPlantTypes(originalPlantTypes);
    setFacilityTypes(originalFacilityTypes);
    setDisplayMarketValues(originalMarketValues);
    setDisplayRegionValues(originalRegionValues);
  };

  // Function to reset all filtered lists to show all available options
  const resetFilteredLists = () => {
    setPlantList(allReceivingPlants);
    setPlannerList(plannerOptions);
    setBrandList(brandOptions);
    setBrandOptions(brandOptions);
    setMFGPlantList(originalMfgPlantList)
    // Reset CMO filtering to show all available CMOs
    setFilteredVendorMosymphonyIDList(
      cmoMemberWithId.map(cmo => cmo.organization_id)
    );
  };

  // Function to reset all previous filter references
  const resetPreviousFilters = () => {
    previousPlannerList.current = [];
    previousPlantList.current = [];
    previousVendorList.current = [];
    previousBrandList.current = [];
    previousMfgPlantList.current = [];
    previousProductTypeList.current = [];
  };

  // Function to reset all selection states
  const resetSelectionStates = () => {
    setSelectedCMOList([]);
    setSelectedCMOs([]);
    setFilteredVendorMosymphonyIDList([]);
    setSelectedPlantIdList([]);
    setFilteredPlantList([]);
    setSelectedPlannerList([]);
    setSelectedBrandList([]);
    setSelectedProductTypeList([]);
  };


  // Function to make API call with cleared filters
  const makeClearedFiltersAPICall = () => {
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    dispatch(
      fetchPurchaseOrdersNew({
        searchField: "all",
        searchValue: null,
        noOfDaysAgo: 0,
        collaboratorTypeID: tokenData.collaborator_type_id,
        vendorMosymphonyID: tokenData?.organization_id || 0,
        scheduleLineStatusID: 0,
        viewPOOption: "all",
        plantCodeList: [],
        vendorMosymphonyIDList: [],
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: [],
        brand: [],
        aslNumberList: [],
        productTypeIDs: [],
        poStatusIDList: null,
        regionCodes: null,
      }, 'withQuickSummary') // Call quick summary when clearing filters
    );
  };



  // Function to reset vendor Mosymphony ID state
  const resetVendorMosymphonyIDState = () => {
    const orgIdNum = tokenData?.organization_id ? tokenData.organization_id : null;
    setTokenVendorMosymphonyID(orgIdNum);
  };

  // Function to reset schedule agreement status ID state
  const resetScheduleAgreementStatusIDState = () => {
    setScheduleAgreementStatusID("0");
  };

  // Function to reset filter by dates state
  const resetFilterByDatesState = () => {
    setFilterByDates("0");
  };

  // Function to reset current page state
  const resetCurrentPageState = () => {
    setCurrentPage(1);
  };

  // Function to reset search field and value states
  const resetSearchFieldAndValueStates = () => {
    setSearchField("all");
    setSearchValue("");
  };

  // Function to reset selected action state
  const resetSelectedActionState = () => {
    setSelectedAction("View all PO");
  };

  // Function to reset selected PO state
  const resetSelectedPOState = () => {
    setSelectedPO(null);
  };

  // Function to reset quick summary filter state
  const resetQuickSummaryFilterState = () => {
    setQuickSummaryFilter(null);
  };

  // Function to reset table height state
  const resetTableHeightState = () => {
    setTableHeight(TABLE_MIN_HEIGHT);
  };


  return (
    <React.Fragment>
      <BackDropLoading />
      <Grid container justifyContent="center" ref={contentRef}>
        <Grid item xs={12}>
          <Grid
            container
            spacing={1}
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "flex-end",
            }}
          >

            <Grid
              item
              spacing={1}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "row",
                // gap: "1rem",
                alignItems: "flex-end",
              }}
            >
              {localStorage.collabType !== "CMO" && (
                <React.Fragment>
                  <Grid
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                      flexDirection: "column",
                      marginTop: "10px",
                      // width:"70%",
                    }}
                  >
                    <Grid>
                      <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                        CMO:
                      </Typography>
                    </Grid>

                    <Grid>
                      <FormControl
                        variant="outlined"
                        size="small"
                        style={{
                          width: "10rem",
                          //  width: "100%",
                          marginRight: "1rem",
                        }}
                        className="dashboard-filter-dropdown"
                      >
                        <Select
                          multiple
                          fullWidth
                          size="small"
                          variant="outlined"
                          displayEmpty
                          value={
                            SelectedCMOList.length > 0 ? SelectedCMOList : []
                          } // Fix: Ensures correct initial display
                          onChange={handleChangeCMOList}
                          onClose={() =>
                            handleSelectChangeListLosesFocus("cmo")
                          }
                          renderValue={(selected) =>
                            selected.length === 0
                              ? "All"
                              : getDisplayCMOFilterValue()
                          }
                        >
                          <MenuItem value="All">
                            <Checkbox
                              checked={
                                SelectedCMOList.length === getAvailableCMOs().length && getAvailableCMOs().length > 0
                              }
                            />
                            <ListItemText primary="All" />
                          </MenuItem>
                          {getAvailableCMOs().map((option) => {
                            return (
                              <MenuItem
                                key={option}
                                value={option.organization_id}
                              >
                                <Checkbox
                                  checked={
                                    SelectedCMOList.indexOf(
                                      option.organization_id
                                    ) > -1
                                  }
                                />
                                <ListItemText
                                  primary={option.organization_name}
                                />
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </React.Fragment>
              )}


              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                  marginTop: "10px",
                  // width:"30%",
                }}
              >
                <Grid>
                  <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                    MFG Plant:
                  </Typography>
                </Grid>

                <Grid>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      width: "10rem",
                      // width: "100%",
                      marginRight: "1rem",
                    }}
                    className="dashboard-filter-dropdown"
                  >
                    <Select
                      multiple
                      fullWidth
                      size="small"
                      variant="outlined"
                      displayEmpty
                      value={
                        selectedMFGPlantList.length > 0
                          ? selectedMFGPlantList
                          : []
                      } // Fix: Ensures correct initial display
                      onChange={handleChangeMFGPlantList}
                      onClose={() =>
                        handleSelectChangeListLosesFocus("mfgPlants")
                      }
                      renderValue={(selected) =>
                        selected.length === 0 ? "All" : getDisplayMFGPlantValue()
                      }
                    >
                      <MenuItem value="All">
                        <Checkbox
                          checked={
                            selectedMFGPlantList.length === mfgPlantList.length
                          }
                        />
                        <ListItemText primary="All" />
                      </MenuItem>
                      {mfgPlantList.map((option) => (
                        <MenuItem key={option} value={option.aslNumber}>
                          <Checkbox
                            checked={selectedMFGPlantList.includes(option.aslNumber)}
                          />
                          <ListItemText primary={option.mfgPlantShortName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* ////////////   */}

              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                  marginTop: "10px",
                  // width:"30%",
                }}
              >
                <Grid>
                  <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                    Plant ID:
                  </Typography>
                </Grid>

                <Grid>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      width: "10rem",
                      // width: "100%",
                      marginRight: "1rem",
                    }}
                    className="dashboard-filter-dropdown"
                  >
                    <Select
                      multiple
                      fullWidth
                      size="small"
                      variant="outlined"
                      displayEmpty
                      value={
                        selectedPlantIdList.length > 0
                          ? selectedPlantIdList
                          : []
                      } 
                      onChange={handleChangePlantIdList}
                      onClose={() =>
                        handleSelectChangeListLosesFocus("plantID")
                      }
                      renderValue={(selected) =>
                        selected.length === 0 ? "All" : getDisplayPlantIDValue()
                      }
                    >
                      <MenuItem value="All">
                        <Checkbox
                          checked={
                            selectedPlantIdList.length === plantList.length
                          }
                        />
                        <ListItemText primary="All" />
                      </MenuItem>
                      {plantList.map((option) => (
                        <MenuItem key={option} value={option.plantCode}>
                          <Checkbox
                            checked={
                              selectedPlantIdList.indexOf(option.plantCode) > -1
                            }
                          />
                          <ListItemText primary={option.plantCode} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {localStorage.collabType !== "CMO" && (
                // localStorage.roleName !== "Planner" &&
                <React.Fragment>
                  <Grid
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                      flexDirection: "column",
                      marginTop: "10px",
                      // width:"30%",
                    }}
                  >
                    <Grid>
                      <Typography className="dashboard-filter-labels">
                        Planner:
                      </Typography>
                    </Grid>

                    <Grid>
                      <FormControl
                        variant="outlined"
                        size="small"
                        style={{
                          width: "10rem",
                          marginRight: "1rem",
                        }}
                        className="dashboard-filter-dropdown"
                      >
                        <Select
                          multiple
                          fullWidth
                          size="small"
                          variant="outlined"
                          displayEmpty
                          value={
                            selectedPlannerList.length > 0
                              ? selectedPlannerList
                              : []
                          }
                          onChange={handleChangePlannerList}
                          onClose={() =>
                            handleSelectChangeListLosesFocus("Planner", userAssociationData)
                          }
                          renderValue={(selected) =>
                            selected.length === 0
                              ? "All"
                              : getDisplayPlannerValue()
                          }
                        >
                          <MenuItem value="All">
                            <Checkbox
                              checked={
                                selectedPlannerList.length ===
                                plannerList.length
                              }
                            />
                            <ListItemText primary="All" />
                          </MenuItem>
                          {plannerList.map((val, ind) => (
                            <MenuItem key={ind} value={val.saasUserID}>
                              <Checkbox checked={selectedPlannerList.includes(val.saasUserID)} />
                              <ListItemText primary={val.name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </React.Fragment>
              )}

              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                  marginTop: "10px",
                  // width:"30%",
                }}
              >

                <Grid>
                  <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">Brand:</Typography>
                </Grid>

                <Grid>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      width: "10rem",
                      marginRight: "1rem",
                    }}
                    className="dashboard-filter-dropdown"
                  >
                    <Select
                      multiple
                      fullWidth
                      size="small"
                      variant="outlined"
                      displayEmpty
                      value={selectedBrandList || []}
                      onChange={handleChangeBrandList}
                      onClose={() => handleSelectChangeListLosesFocus("brand", userAssociationData)}
                      renderValue={() => getDisplayBrandValue()}
                    >
                      <MenuItem value="All">
                        <Checkbox
                          checked={
                            selectedBrandList.length ===
                            uniqueBrandOptions.length &&
                            uniqueBrandOptions.length > 0
                          }
                        />
                        <ListItemText primary="All" />
                      </MenuItem>
                      {uniqueBrandOptions.map((option) => {
                        const titleCaseBrand = option?.brand && option?.brand
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ");
                        return (
                          <MenuItem key={option?.brand} value={option?.brand}>
                            <Checkbox
                              checked={selectedBrandList.includes(option?.brand)}
                            />
                            <ListItemText primary={titleCaseBrand} />
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                  marginTop: "10px",
                  // width:"30%",
                }}
              >

                <Grid>
                  <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">Product Type:</Typography>
                </Grid>

                <Grid>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      width: "10rem",
                      marginRight: "1rem",
                    }}
                    className="dashboard-filter-dropdown"
                  >
                    <Select
                      multiple
                      fullWidth
                      size="small"
                      variant="outlined"
                      displayEmpty
                      value={selectedProductTypeList || []}
                      onChange={handleChangeProductTypeList}
                      onClose={() => handleSelectChangeListLosesFocus("productType", userAssociationData)}
                      renderValue={() => getDisplayProductTypeValue()}
                    >
                      <MenuItem value="All">
                        <Checkbox
                          checked={
                            selectedProductTypeList.length ===
                            productTypeList.length &&
                            productTypeList.length > 0
                          }
                        />
                        <ListItemText primary="All" />
                      </MenuItem>
                      {productTypeList.map((option) => (
                        <MenuItem key={option?.productTypeID} value={option?.productTypeID}>
                          <Checkbox
                            checked={selectedProductTypeList.includes(option?.productTypeID)}
                          />
                          <ListItemText primary={option?.productTypeName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "20px",
                  // width:"15%",
                  flexDirection: "column",
                  // marginTop: "1.5rem",
                }}
              >
                <Button
                  variant="contained"
                  // color="primary"
                  disableElevation
                  disableRipple
                  disableFocusRipple
                  className={`${classes.stylebutton} dashboard-save-filter-btn`}
                  onClick={handleSaveFilter}
                // style={{
                //   borderRadius: "2rem",
                //   textTransform: "none",
                // }}
                >
                  Save Filters
                </Button>
              </Grid>

              <Grid
                style={{
                  display: "flex",
                  // width:"15%",
                  // alignItems: "flex-start",
                  // gap: "20px",
                  // flexDirection: "column",
                  // marginTop: "1.5rem",
                }}
              >
                <Typography
                  variant="caption"
                  style={{
                    // width:"100%",
                    justifyContent: "end",
                    fontSize: "14px",
                    color: "blue",
                    marginLeft: "5px",
                  }}
                  className={classes.clearText}
                  onClick={handleClearFilters}
                >
                  Clear All Filters
                </Typography>
              </Grid>
            </Grid>

            {/* ********************************************* */}

            <Grid
              item
              // xs={12}
              // sm={2}
              // md={2}
              style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}
            >
              {featuresAccess?.uploadPO && (localStorage.getItem("collabType") !== "CMO" || vendorPlantDetails?.cmoToUsePOInterface === true) && (
                <Button
                  variant="outlined"
                  className={classes.outlineButton}
                  onClick={handleUploadPOs}
                  style={{
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    minWidth: "115px"
                  }}
                >
                  Upload POs
                </Button>
              )}
              {featuresAccess?.allocatePO && localStorage.getItem("collabType") !== "CMO" && (
                <Button
                  variant="outlined"
                  className={classes.outlineButton}
                  onClick={() => setOpenAllocatePOs(true)}
                  style={{
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    minWidth: "115px",
                  }}
                >
                  Allocate POs
                </Button>
              )}
              <Button
                variant="outlined"
                className={classes.outlineButton}
                onClick={handleDownloadData}
                style={{
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  minWidth: "115px"
                }}
              >
                Download POs
              </Button>
              {featuresAccess?.markPoForDelete && (
                <Button
                  variant="contained"
                  style={{
                    minWidth: "145px",
                  }}
                  className={classes.btnDelete}
                  onClick={() => setMarkDeleteModalOpen(true)}
                >
                  Mark PO for Delete
                </Button>
              )}
              {/* <Button
                style={{ whiteSpace: "nowrap" }}
                // startIcon={<AddIcon />}
                // onClick={() => setInviteDrawer(true)}
                // onClick={() => {
                //   setOpenUploadDSBatch(true);
                // }}
                className={classes.upload}
              >
                Attach documents
              </Button> */}
              {/* {featuresAccess?.eventBasedAnalytics && (
                <Button
                  style={{ whiteSpace: "nowrap", textTransform: "uppercase" }}
                  className={classes.customButton}
                  variant="contained"
                >
                  Event based analytics
                </Button>
              )} */}
            </Grid>
          </Grid>

          {/* BCM-435: New Mark PO for Delete Modal */}
          <MarkPOForDeleteModal
            open={markDeleteModalOpen}
            onClose={() => setMarkDeleteModalOpen(false)}
            onSuccess={handleRefresh}
          />

          <Dialog
            open={openMdCheck}
            onClose={closeMdCheckDialog}
            fullWidth
            maxWidth="md"
            PaperProps={{ style: { borderRadius: 14, paddingLeft: 10 } }}
          >
            <DialogContent className={classes.mdWrap}>
              <Grid container justifyContent="flex-end" style={{ marginBottom: 8 }}>
                <Typography className={classes.mdCloseText} variant="body2" onClick={closeMdCheckDialog}>
                  Cancel <CloseIcon style={{ marginLeft: 4, color: "#FF0000" }} fontSize="large" />
                </Typography>
              </Grid>

              <Typography className={classes.mdTitle} style={{ marginBottom: 36 }}>Check details of PO to be deleted</Typography>

              <div style={{ marginTop: 16, marginBottom: 42 }}>
                <Typography style={{ fontWeight: 700, textAlign: "left", fontSize: 18 }}>PO Details</Typography>
                <span className={classes.borders}></span>

              </div>

              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} sm={4}>
                  <div className={classes.mdField}>
                    <Typography style={{ fontWeight: 600, fontSize: 13, marginBottom: 8, textAlign: "left" }}>PO Number</Typography>

                    <Autocomplete
                      options={mdUniquePOs}
                      loading={mdLoadingPOs}
                      getOptionLabel={(o) => o?.scheduleAgreementNumber || ""}
                      value={(mdUniquePOs || []).find(o => o?.scheduleAgreementNumber === mdCheckPo) || null}
                      onChange={(_, val) => setMdCheckPo(val?.scheduleAgreementNumber || "")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder={mdLoadingPOs ? "Loading..." : "Search PO number"}
                          className={classes.mdDenseControl}
                        />
                      )}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>

              {/* Two sections of 3 fields each, left-aligned */}
              {(() => {
                const info = mdCheckPo ? getMdPoDetails(mdCheckPo) : null;
                const NA = { cmo: "NA", cmoId: "NA", productCode: "NA", productDesc: "NA", qty: "NA", uom: "NA", date: "NA" };
                const d = info || NA;

                return (
                  <>
                    {/* Section 1: CMO, CMO ID, Product Code/Desc */}
                    <Grid container spacing={3} style={{ marginTop: 32 }}>
                      <Grid item xs={12} sm={4}>
                        <Typography style={{ fontWeight: 600, fontSize: 14, marginBottom: 6, textAlign: "left" }}>CMO</Typography>
                        <Typography style={{ fontSize: 14, textAlign: "left" }}>{d.cmo}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography style={{ fontWeight: 600, fontSize: 14, marginBottom: 6, textAlign: "left" }}>CMO ID</Typography>
                        <Typography style={{ fontSize: 14, textAlign: "left" }}>{d.cmoId}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography style={{ fontWeight: 600, fontSize: 14, marginBottom: 6, textAlign: "left" }}>Product Code / Description</Typography>
                        <Typography style={{ fontSize: 14, textAlign: "left" }}>{d.productCode}/{d.productDesc}</Typography>
                      </Grid>
                    </Grid>

                    {/* Section 2: Qty, UoM, Current Date */}
                    <Grid container spacing={3} style={{ marginTop: 16 }}>
                      <Grid item xs={12} sm={4}>
                        <Typography style={{ fontWeight: 600, fontSize: 14, marginBottom: 6, textAlign: "left" }}>Current Qty.</Typography>
                        <Typography style={{ fontSize: 14, textAlign: "left" }}>{d.qty}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography style={{ fontWeight: 600, fontSize: 14, marginBottom: 6, textAlign: "left" }}>UoM</Typography>
                        <Typography style={{ fontSize: 14, textAlign: "left" }}>{d.uom}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography style={{ fontWeight: 600, fontSize: 14, marginBottom: 6, textAlign: "left" }}>Current Date</Typography>
                        <Typography style={{ fontSize: 14, textAlign: "left" }}>{d.date}</Typography>
                      </Grid>
                    </Grid>
                  </>
                );
              })()}

              {/* CTA */}
              <div className={classes.mdCtaRow} style={{ marginTop: 52, marginBottom: 24 }}>
                <Button
                  className={classes.mdPrimaryBtn}
                  variant="contained"
                  onClick={openMarkDeleteDialogFromCheck}
                  disabled={!mdCheckPo}
                >
                  Mark PO for Delete
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          <Dialog
            open={openMarkDelete}
            onClose={closeMarkDeleteDialog}
            fullWidth
            maxWidth={false}
            PaperProps={{
              style: {
                borderRadius: 14,
                width: '80%',
                maxWidth: '800px',
                minWidth: '500px',
              },
            }}
          >
            <DialogContent className={classes.mdWrap}>
              <Grid container justifyContent="flex-end" style={{ marginBottom: 8 }}>
                <Typography className={classes.mdCloseText} variant="body2" onClick={closeMarkDeleteDialog}>
                  Cancel <CloseIcon style={{ marginLeft: 4, color: "#FF0000" }} fontSize="large" />
                </Typography>
              </Grid>

              <Typography className={classes.mdTitle}>Marking PO for Delete</Typography>

              <div className={classes.mdFieldTitle}>
                <Typography style={{ fontWeight: 400, fontSize: 17, color: "#000" }}>Are you sure you want to mark this PO for deletion?</Typography>
              </div>

              <div className={classes.mdFieldWrap}>
                <div className={classes.mdField}>
                  <Typography style={{ fontWeight: 700, marginBottom: 4 }}>PO Number</Typography>
                  <Typography>{mdPoNumber || ""}</Typography>
                </div>

                {/* Reason Code / Description */}
                <div className={classes.mdField}>
                  <Typography style={{ fontWeight: 700, marginBottom: 4 }}>
                    Reason Code / Description
                  </Typography>
                  <FormControl variant="outlined" fullWidth className={classes.mdDenseControl}>
                    <Select
                      value={mdReasonCode}
                      onChange={(e) => setMdReasonCode(e.target.value)}
                      displayEmpty
                      disabled={mdLoadingReasons}
                      renderValue={(val) => {
                        if (!val) {
                          return <em>{mdLoadingReasons ? "Loading..." : "Select Reason Code / Description"}</em>;
                        }
                        const selectedOption = mdReasonOptions.find(opt => opt.reasonCode === val);
                        return selectedOption
                          ? `${selectedOption.reasonCode} / ${selectedOption.reasonDescription || ""}`
                          : val;
                      }}
                    >
                      <MenuItem value="">
                        <em>Select Reason Code / Description</em>
                      </MenuItem>
                      {!mdLoadingReasons && mdReasonOptions.map((opt) => (
                        <MenuItem
                          key={`${opt.reasonCode}-${opt.reasonCodeID || opt.id || "x"}`}
                          value={opt.reasonCode}
                        >
                          {opt.reasonCode} / {opt.reasonDescription || ""}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                {/* Comment */}
                <div className={classes.mdField} style={{ marginBottom: 0 }}>
                  <Typography style={{ fontWeight: 700, marginBottom: 4 }}>Comment</Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    multiline
                    // rows={2}
                    placeholder="Enter text here"
                    value={mdComment}
                    onChange={(e) => {
                      if (e.target.value.length < 256) {
                        setMdComment(e.target.value)
                      }
                    }}
                    onBlur={(e) => {
                      const { value } = e.target;
                      // Trim leading and trailing spaces for string values
                      if (typeof value === "string" && value.trim() !== value) {
                        setMdComment(value.trim());
                      }
                    }}
                    className={classes.mdComment}
                  />

                  <Typography className={classes.mdNote} style={{ marginTop: 2 }}>
                    Note - If reason code is not entered, comment field is mandatory.
                  </Typography>
                  {mdGeneralError && (
                    <Typography
                      variant="body2"
                      color="error"
                      style={{
                        marginTop: 8,
                        padding: "8px 12px",
                        backgroundColor: "#ffebee",
                        border: "1px solid #f44336",
                        borderRadius: 4,
                      }}
                    >
                      {mdGeneralError}
                    </Typography>
                  )}
                </div>

              </div>

              <div className={classes.mdCtaRow}>
                <Button
                  className={classes.mdPrimaryBtn}
                  variant="contained"
                  onClick={handleConfirmMarkDelete}
                  disabled={mdSubmitting}
                  startIcon={mdSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
                >
                  Confirm Deletion
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          {/* Success Dialog */}
          <Dialog
            open={mdResultOpen && mdResultType === "success"}
            onClose={() => { setMdResultOpen(false); handleRefresh(); }}
            fullWidth
            maxWidth="xs"
            PaperProps={{ style: { borderRadius: 6 } }}
          >
            <DialogContent style={{ padding: 24 }}>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12} style={{ display: "flex", justifyContent: "center", marginBottom: 12, marginTop: 10 }}>
                  <span
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      background: "#2E7D32",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "none",
                    }}
                  >
                    <DoneIcon style={{ fontSize: 46, color: "#FFFFFF" }} />
                  </span>
                </Grid>

                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: 22,
                      whiteSpace: "pre-line",
                      paddingTop: 16,
                      paddingBottom: 16,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    {mdResultTitle /* e.g. `PO Number 733627 marked\nfor deletion successfully` */}
                  </Typography>
                </Grid>

                <Grid item xs={12} style={{ display: "flex", justifyContent: "center", marginTop: 16, marginBottom: 10 }}>
                  <Button
                    onClick={() => { setMdResultOpen(false); handleRefresh(); }}
                    variant="contained"
                    style={{
                      backgroundColor: "#ec6535",
                      color: "#fff",
                      borderRadius: 20,
                      textTransform: "none",
                      minWidth: 124,
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 24,
                      paddingRight: 24,
                      height: 34,
                    }}
                  // endIcon={<ChevronRight />}
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>

          {/* Error Dialog*/}
          <Dialog
            open={mdResultOpen && mdResultType === "error"}
            onClose={() => { setMdResultOpen(false); handleRefresh(); }}
            fullWidth
            maxWidth="sm"
            PaperProps={{ style: { borderRadius: 14 } }}
          >
            <DialogContent style={{ padding: 24 }}>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12} style={{ display: "flex", justifyContent: "center", marginBottom: 12, marginTop: 10 }}>
                  <div style={{
                    width: "5rem",
                    height: "5rem",
                    borderRadius: "50%",
                    backgroundColor: "#F00",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white"
                  }}>
                    <CloseIcon
                      style={{
                        fontSize: "3rem",
                        color: "white",
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <Typography style={{ fontWeight: 700, fontSize: 22, whiteSpace: "pre-line" }}>
                    {mdResultTitle}
                  </Typography>
                  {mdResultSubtext && (
                    <Typography style={{ marginTop: 12, whiteSpace: "pre-line" }}>
                      {mdResultSubtext}
                    </Typography>
                  )}
                  {/* backend error*/}
                  {mdResultMessage && (
                    <Typography style={{
                      textAlign: "center",
                      fontSize: '1rem',
                      color: '#d32f2f',
                      fontWeight: 'normal',
                      marginTop: 12
                    }}>
                      {mdResultMessage}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "center", marginTop: 24, marginBottom: 10 }}>
                  <Button
                    onClick={() => { setMdResultOpen(false); handleRefresh(); }}
                    variant="contained"
                    style={{
                      backgroundColor: "#ec6535",
                      color: "#fff",
                      borderRadius: 20,
                      textTransform: "none",
                      minWidth: 124,
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 24,
                      paddingRight: 24,
                      height: 34,
                    }}
                    endIcon={<ChevronRight />}
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>

          {/* Excel Preview Dialog */}
          <Dialog
            open={openExcelPreview}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                handleCloseExcelPreview();
              }
            }}
            fullWidth
            maxWidth="lg"
            PaperProps={{ style: { borderRadius: 14 } }}
            disableEscapeKeyDown
          >
            <DialogContent style={{ padding: 24 }}>
              <Grid container justifyContent="flex-end" style={{ marginBottom: 8 }}>
                <Typography
                  style={{
                    fontSize: "1rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={handleCloseExcelPreview}
                >
                  Close <CloseIcon style={{ marginLeft: 4, color: "#FF0000" }} fontSize="large" />
                </Typography>
              </Grid>

              <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Box display="flex" alignItems="center">
                  <img
                    src="https://img.icons8.com/color/96/000000/microsoft-excel-2019--v1.png"
                    alt="Excel file"
                    style={{ width: '48px', height: '48px', marginRight: '16px' }}
                  />
                  <Box>
                    <Typography variant="h6" style={{ margin: 0, fontWeight: 600 }}>
                      Purchase Orders Data
                    </Typography>
                    <Typography variant="body2" style={{ margin: 0, color: '#666' }}>
                      Excel Spreadsheet Preview
                    </Typography>
                  </Box>
                </Box>
                <Box display="flex" gap={2}>
                  {excelFileURL && (
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<CloudDownload />}
                      href={excelFileURL}
                      download={excelFileName}
                      style={{ textTransform: 'none' }}
                    >
                      Download
                    </Button>
                  )}
                </Box>
              </Box>

              {excelLoading ? (
                <Box display="flex" justifyContent="center" height="200px" alignItems="center">
                  <CircularProgress color="primary" />
                </Box>
              ) : excelData && excelData.length > 0 ? (
                <>
                  <TableContainer ref={tableContainerRef} component={Paper} style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto' }}>
                    <Table size="small" style={{ position: 'relative', borderCollapse: 'separate', borderSpacing: 0 }}>
                      <TableHead>
                        {/* Column Headers Row */}
                        <TableRow>
                          {excelData[0] && excelData[0].map((cell, i) => {
                            // Determine background color based on column index
                            let bgColor = '#fff';
                            if (i >= 8 && i <= 11) {
                              // Columns 8-11: Custom color
                              bgColor = '#A3C3EF';
                            } else if (i < 17) {
                              // General PO Information (columns 0-16): 17 cols
                              bgColor = '#fff';
                            } else if (i < 26) {
                              // PO Details (columns 17-25): 9 cols
                              bgColor = '#D0E0E3';
                            } else if (i < 35) {
                              // Product Details (columns 26-34): 9 cols
                              bgColor = '#F4CCCC';
                            } else if (i < 49) {
                              // LOT Allocation (columns 35-48): 14 cols
                              bgColor = '#FCE5CD';
                            } else if (i < 55) {
                              // Delivery Details (columns 49-54): 6 cols
                              bgColor = '#D9EAD3';
                            } else {
                              // Time and Qty Details (columns 55+): 2 cols
                              bgColor = '#FFF2CC';
                            }

                            return (
                              <TableCell
                                key={i}
                                style={{
                                  fontWeight: 'bold',
                                  backgroundColor: bgColor,
                                  whiteSpace: 'nowrap',
                                  borderTop: '1px solid #000',
                                  borderLeft: '1px solid #000',
                                  borderRight: '1px solid #000',
                                  borderBottom: '1px solid #000',
                                  textAlign: 'center',
                                  color: '#000',
                                  padding: '8px',
                                  position: 'sticky',
                                  top: 0,
                                  zIndex: i === 0 ? 5 : 3,
                                  left: i === 0 ? 0 : 'auto'
                                }}
                              >
                                {cell}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(() => {
                          const headerRows = 1; // Purchase Orders has 1 header row
                          const dataRows = excelData.slice(headerRows);

                          // Group rows by PO Number
                          const groupedData = groupRowsByPO(dataRows);

                          // Paginate grouped results
                          const paginatedGroups = groupedData.slice(
                            excelPage * 50,
                            (excelPage + 1) * 50
                          );

                          const renderedRows = [];

                          paginatedGroups.forEach((group, groupIdx) => {
                            const hasSubRows = group.subRows.length > 0;

                            // Render parent row
                            renderedRows.push(
                              <TableRow key={`parent-${group.poNumber}-${groupIdx}`} hover>
                                {group.parentRow.map((cell, j) => {
                                  const cellValue = cell !== null && cell !== undefined ? String(cell) : '';
                                  const hasLineBreaks = cellValue.includes('\n');

                                  // Determine background color for columns 8-11 only
                                  let bgColor = hasSubRows ? '#f5f5f5' : 'transparent';
                                  if (j >= 8 && j <= 11) {
                                    bgColor = '#A3C3EF';
                                  }

                                  return (
                                    <TableCell
                                      key={j}
                                      style={{
                                        whiteSpace: hasLineBreaks ? 'pre-wrap' : 'nowrap',
                                        padding: '8px',
                                        borderTop: '1px solid #000',
                                        borderLeft: '1px solid #000',
                                        borderRight: '1px solid #000',
                                        borderBottom: hasSubRows ? '1px solid #ddd' : '1px solid #000',
                                        position: j === 0 ? 'sticky' : 'relative',
                                        left: j === 0 ? 0 : 'auto',
                                        backgroundColor: j === 0 ? '#fff' : bgColor,
                                        zIndex: j === 0 ? 2 : 'auto',
                                        fontWeight: 'normal',
                                        verticalAlign: 'top'
                                      }}
                                    >
                                      {cellValue}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            );

                            // Render sub-rows directly (always visible)
                            if (hasSubRows) {
                              group.subRows.forEach((subRow, subIdx) => {
                                renderedRows.push(
                                  <TableRow key={`sub-${group.poNumber}-${subIdx}`} hover>
                                    {group.parentRow.map((cell, j) => {
                                      // For sub-rows, get the actual cell value from the subRow data
                                      const subRowCell = subRow.row[j];
                                      const cellValue = subRowCell !== null && subRowCell !== undefined ? String(subRowCell) : '';
                                      const hasLineBreaks = cellValue.includes('\n');

                                      // Determine background color for columns 8-11 only
                                      let bgColor = '#fafafa';
                                      if (j >= 8 && j <= 11) {
                                        bgColor = '#A3C3EF';
                                      }

                                      return (
                                        <TableCell
                                          key={j}
                                          style={{
                                            whiteSpace: hasLineBreaks ? 'pre-wrap' : 'nowrap',
                                            padding: '8px',
                                            paddingLeft: j === 0 ? '40px' : '8px',
                                            borderTop: '1px solid #ddd',
                                            borderLeft: '1px solid #000',
                                            borderRight: '1px solid #000',
                                            borderBottom: subIdx === group.subRows.length - 1 ? '1px solid #000' : '1px solid #ddd',
                                            position: j === 0 ? 'sticky' : 'relative',
                                            left: j === 0 ? 0 : 'auto',
                                            backgroundColor: j === 0 ? '#fff' : bgColor,
                                            zIndex: j === 0 ? 2 : 'auto',
                                            fontSize: '0.95em',
                                            verticalAlign: 'top'
                                          }}
                                        >
                                          {cellValue}
                                        </TableCell>
                                      );
                                    })}
                                  </TableRow>
                                );
                              });
                            }
                          });

                          return renderedRows;
                        })()}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {(() => {
                    const headerRows = 2; // Purchase Orders has 2 header rows
                    const dataRows = excelData.slice(headerRows);
                    const totalPages = Math.ceil(dataRows.length / 50);
                    return totalPages > 1 ? (
                      <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                        <IconButton
                          size="small"
                          onClick={() => {
                            setExcelPage((prev) => Math.max(prev - 1, 0));
                            if (tableContainerRef.current) {
                              tableContainerRef.current.scrollTop = 0;
                              tableContainerRef.current.scrollLeft = 0;
                            }
                          }}
                          disabled={excelPage === 0}
                          style={{ marginRight: 8 }}
                        >
                          <ChevronLeft fontSize="small" />
                        </IconButton>
                        <Typography>
                          Page {excelPage + 1} of {totalPages}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => {
                            setExcelPage((prev) => Math.min(prev + 1, totalPages - 1));
                            if (tableContainerRef.current) {
                              tableContainerRef.current.scrollTop = 0;
                              tableContainerRef.current.scrollLeft = 0;
                            }
                          }}
                          disabled={excelPage >= totalPages - 1}
                          style={{ marginLeft: 8 }}
                        >
                          <ChevronRight fontSize="small" />
                        </IconButton>
                      </Box>
                    ) : null;
                  })()}
                </>
              ) : (
                <Box display="flex" justifyContent="center" height="200px" alignItems="center">
                  <Typography>No data available</Typography>
                </Box>
              )}
            </DialogContent>
          </Dialog>

          {/* Allocate POs Modal */}
          <AllocatePOsModal 
            open={openAllocatePOs} 
            onClose={() => setOpenAllocatePOs(false)} 
          />

          <Grid container>
            <Grid
              item
              style={{
                width: "100%",
              }}
            >
              <Accordion
                expanded={expanded}
                onChange={() => setExpanded(!expanded)}
                style={{
                  boxShadow: "none",
                  marginTop: "1rem",
                  border: "1px solid #B4B4B4",
                }}
              >
                <AccordionSummary
                  className={classes.accordionSummary}
                >
                  <Grid container style={{ justifyContent: "space-between" }}>
                    <Grid item>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <IconButton
                          style={{ marginRight: "8px" }}
                          onClick={() => {
                            if (sideBarOpen) {
                              setExpanded(false); // 🚀 force close QuickSummary if sidebar is open
                            } else {
                              setExpanded((prev) => !prev); // normal toggle
                            }
                          }}
                          size="small"
                        >
                          {expanded ? <ExpandMoreIcon /> : <ChevronRight />}
                        </IconButton>
                        <Typography
                          variant="body2"
                          style={{ paddingBottom: "inherit", fontWeight: 600 }}

                        >
                          Quick Summary:
                        </Typography>
                      </div>
                    </Grid>
                    {scheduleAgreementStatusID !== "0" && (
                      <Grid item>
                        <Typography
                          variant="caption"
                          color="primary"
                          onClick={handleCleanQuickSummary}
                          className={clsx(
                            classes.dpFlx,
                            classes.algnCntr,
                            classes.pointer,
                            classes.onHvrUndrline
                          )}
                        >
                          Clear Quick Summary
                          <ClearIcon color="primary" style={{ fontSize: 15 }} />
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={1}
                    wrap="nowrap"
                    style={{
                      overflowX: "auto",
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "0rem",
                      // padding: "0.5rem",
                    }}
                  >
                    <Block
                      lableText={"New POs"}
                      value={22}
                      handleQuickStatus={(val) =>
                        handleQuickStatus(val, "status")
                      }
                      selectedValue={quickSummaryFilter}
                      loading={poQuickSummaryLoading}
                      count={
                        Array.isArray(poQuickSummary?.statusCount)
                          ? poQuickSummary?.statusCount.filter(
                            (val) =>
                              val.scheduleLineStatusID === 22 && val?.count
                          ).length > 0
                            ? poQuickSummary?.statusCount.filter(
                              (val) => val.scheduleLineStatusID === 22
                            )[0].count
                            : 0
                          : 0
                      }
                    />

                    {/* BMS Only - Ready for Allocation */}
                    {localStorage.collabType !== "CMO" && (
                      <Block
                        lableText={"POs Ready for Allocation"}
                        value={"View PO which are ready for allocation"}
                        handleQuickStatus={(val) =>
                          handleQuickStatus(val, "PO_Action")
                        }
                        className="quick-summary-count"
                        selectedValue={quickSummaryFilter}
                        loading={poQuickSummaryLoading}
                        count={
                          poQuickSummary?.quickSummaryData
                            ?.readyForAllocationCount ?? 0
                        }
                      />
                    )}

                    {/* BMS Only - Pending Approval */}
                    {localStorage.collabType !== "CMO" && (
                      <Block
                        lableText={"POs with Pending Approval"}
                        value={"View PO with pending approvals"}
                        handleQuickStatus={(val) =>
                          handleQuickStatus(val, "PO_Action")
                        }
                        className="quick-summary-count"
                        selectedValue={quickSummaryFilter}
                        loading={poQuickSummaryLoading}
                        count={
                          poQuickSummary?.quickSummaryData
                            ?.pendingApprovalCount ?? 0
                        }
                      />
                    )}

                    {/* CMO Only - Allocation Done */}
                    {localStorage.collabType === "CMO" && (
                      <Block
                        lableText={"POs with Allocation Done"}
                        value={"View PO with Allocation Done"}
                        handleQuickStatus={(val) =>
                          handleQuickStatus(val, "PO_Action")
                        }
                        className="quick-summary-count"
                        selectedValue={quickSummaryFilter}
                        loading={poQuickSummaryLoading}
                        count={
                          poQuickSummary?.quickSummaryData?.allocationDoneCount ?? 0
                        }
                      />
                    )}

                    {/* CMO Only - Over-Allocation */}
                    {localStorage.collabType === "CMO" && (
                      <Block
                        lableText={"POs with Over/Under Allocation"}
                        value={"View PO with Over And Under Allocation"}
                        handleQuickStatus={(val) =>
                          handleQuickStatus(val, "PO_Action")
                        }
                        className="quick-summary-count"
                        selectedValue={quickSummaryFilter}
                        loading={poQuickSummaryLoading}
                        count={
                          poQuickSummary?.quickSummaryData?.overAndUnderAllocationCount ?? 0
                        }
                      />
                    )}

                    <Block
                      lableText={"POs with changes"}
                      value={"View POs with new PO changes"}
                      handleQuickStatus={(val) =>
                        handleQuickStatus(val, "PO_Action")
                      }
                      className="quick-summary-count"
                      selectedValue={quickSummaryFilter}
                      loading={poQuickSummaryLoading}
                      count={
                        poQuickSummary?.quickSummaryData?.poChangesCount ?? 0
                      }
                    />

                    <Block
                      lableText={"POs ready for dispatch"}
                      value={"View PO with batch in ready for dispatch status"}
                      handleQuickStatus={(val) =>
                        handleQuickStatus(val, "PO_Action")
                      }
                      className="quick-summary-count"
                      selectedValue={quickSummaryFilter}
                      loading={poQuickSummaryLoading}
                      count={
                        poQuickSummary?.quickSummaryData?.readyForDispatchCount
                          ? poQuickSummary?.quickSummaryData
                            ?.readyForDispatchCount
                          : 0
                      }
                    />

                    <Block
                      lableText={"POs delayed"}
                      value={"View PO with expected and actual delivery delays"}
                      handleQuickStatus={(val) =>
                        handleQuickStatus(val, "PO_Action")
                      }
                      selectedValue={quickSummaryFilter}
                      loading={poQuickSummaryLoading}
                      count={
                        poQuickSummary?.quickSummaryData?.deliveryDelayedCount
                          ? poQuickSummary?.quickSummaryData
                            ?.deliveryDelayedCount
                          : 0
                      }
                    />

                    <Block
                      lableText={"POs with new comments"}
                      value={"View POs with new comments"}
                      handleQuickStatus={(val) =>
                        handleQuickStatus(val, "PO_Action")
                      }
                      selectedValue={quickSummaryFilter}
                      loading={poQuickSummaryLoading}
                      count={
                        poQuickSummary?.quickSummaryData?.poWithNewCommentsCount
                          ? poQuickSummary?.quickSummaryData
                            ?.poWithNewCommentsCount
                          : 0
                      }
                    />

                    {/* <Block
                      lableText={"CMO proposed changes"}
                      value={"View PO with new CMO proposed values"}
                      handleQuickStatus={(val) =>
                        handleQuickStatus(val, "PO_Action")
                      }
                      selectedValue={quickSummaryFilter}
                      loading={poQuickSummaryLoading}
                      count={
                        poQuickSummary?.quickSummaryData?.cmoProposedCount
                          ? poQuickSummary?.quickSummaryData?.cmoProposedCount
                          : 0
                      }
                    />
                    <Block
                      lableText={"Sponsor proposed changes"}
                      value={"View PO with new Sponsor proposed values"}
                      handleQuickStatus={(val) =>
                        handleQuickStatus(val, "PO_Action")
                      }
                      selectedValue={quickSummaryFilter}
                      loading={poQuickSummaryLoading}
                      count={
                        poQuickSummary?.quickSummaryData?.sponsorProposedCount
                          ? poQuickSummary?.quickSummaryData
                              ?.sponsorProposedCount
                          : 0
                      }
                    /> */}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>

          <Grid
            container
            // spacing={2}
            style={{
              display: "flex",
              width: "100%",
              // justifyContent: "space-between",
              alignItems: "end",
              flexWrap: "nowrap",
              marginTop: "1rem",
              gap: "15px"
            }}
          >
            {/* <Grid
              item
              style={{
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "row",
                gap:"0.5rem"
              }}
            > */}
            <Grid
              item
              xs={12}
              sm={5}
              md={5}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                justifyContent: "flex-start",
              }}
            >
              <Grid>
                <Typography
                  style={{
                    fontWeight: 550,
                    whiteSpace: "nowrap",
                    marginBottom: "1rem",
                  }}
                  className="dashboard-filter-labels"
                >
                  Search by:
                </Typography>
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                  className="select-search-by-field"
                >
                  <TextField
                    size="small"
                    select
                    value={searchField}
                    onChange={handleSearchField}
                    onKeyDown={(e) => e.key === "Enter" && handleSearchField()}
                    variant="outlined"
                    style={{
                      border: "1px solid black",
                      borderRight: "none",
                      borderRadius: "0.1rem",
                      backgroundColor: "#F0F0F0",
                      width: "200px",
                      overflow: "hidden",
                    }}
                    className="select-search"
                    inputProps={{
                      style: {
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    {/* <Box
                  style={{
                    width: "30rem",
                    display: "flex",
                    alignItems: "center",select-search-by-field
                  }}
                > */}
                    <MenuItem value="all">Select Criteria</MenuItem>
                    <MenuItem value="PO Number">PO Number</MenuItem>
                    <MenuItem value="Product Code">Product Code</MenuItem>
                    <MenuItem value="Product description">
                      Product Description
                    </MenuItem>
                    <MenuItem value="BMS Component / Material Code">
                      BMS Component / Material Code
                    </MenuItem>
                    <MenuItem value="BMS Component / Material Description">
                      BMS Component / Material Description
                    </MenuItem>
                    <MenuItem value="Allocated BMS Component / Material Batch Number">
                      Allocated BMS Component / Material Batch Number
                    </MenuItem>
                    <MenuItem value="Date of PO Creation">
                      Date of PO Creation
                    </MenuItem>
                    <MenuItem value="Market">Market</MenuItem>
                    <MenuItem value="PO Status">PO Status</MenuItem>
                    <MenuItem value="Region">Region</MenuItem>
                  </TextField>

                  {!["PO Status", "Market", "Region", "Date of PO Creation"].includes(searchField) && (
                    <TextField
                      // className="search-textbox"
                      size="small"
                      value={searchValue}
                      disabled={searchField === "all"}
                      onChange={(e) => {
                        if (searchField !== "all") {
                          handleSearchValue(e);
                        }
                      }}
                      onBlur={(e) => {
                        const { name, value } = e.target;
                        // Trim leading and trailing spaces for string values
                        if (searchField !== "all" && typeof value === "string" && value.trim() !== value) {
                          handleSearchValue({ target: { name, value: value.trim() } });
                        }
                      }}
                      onKeyDown={(e) => {
                        const { name, value } = e.target;
                        if (e.key === "Enter") {
                          handleSearchValue({ target: { name, value: value.trim() } });
                          handleSearchClick()
                        }
                      }}
                      variant="outlined"
                      placeholder="Search"
                      style={{
                        flex: 1,
                        minWidth: 0,
                        border: "1px solid black",
                        borderTopRightRadius: "8px",
                        borderBottomRightRadius: "8px",
                        borderTopLeftRadius: "0px",
                        borderBottomLeftRadius: "0px",
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchValue && (
                              <Tooltip title="Clear search" aria-label="clear">
                                <Clear
                                  fontSize="small"
                                  onClick={handleClearSearch}
                                  style={{
                                    cursor: "pointer",
                                    color: "dimgray",
                                  }}
                                />
                              </Tooltip>
                            )}
                            <IconButton
                              size="small"
                              style={{
                                backgroundColor: "#EB5E28",
                                color: "white",
                                borderTopRightRadius: "7px",
                                //width: 400
                                borderBottomRightRadius: "7px",
                                borderTopLeftRadius: "0px",
                                borderBottomLeftRadius: "0px",
                                padding: "8px",
                                translate: "0.84rem",
                                marginLeft: "0px",
                                marginRight: "0px",

                              }}
                              onClick={handleSearchClick}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    // style={{
                    //   width: "50vw",
                    //   flex: 1,
                    //   border: "1px solid black",
                    //   borderRadius: "0.1rem",
                    // }}
                    />
                  )}

                  {searchField === "Region" && (
                    <Box style={{ position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
                      <FormControl
                        fullWidth
                        style={{
                          width: "100%",
                          height: "40px",
                          minHeight: "40px",
                          maxHeight: "40px",
                          border: "1px solid black",
                          borderTopRightRadius: "8px",
                          borderBottomRightRadius: "8px",
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                          overflow: "hidden",
                        }}
                      >
                        <Select
                          multiple
                          fullWidth
                          variant="outlined"
                          disableUnderline
                          value={selectedRegions.map(r => r.regionCode)}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.includes("All")) {
                              // Toggle select all / unselect all
                              setSelectedRegions(
                                selectedRegions.length === displayRegionValues.length ? [] : displayRegionValues
                              );
                              setSearchValue(
                                selectedRegions.length === displayRegionValues.length ? [] : displayRegionValues.map(r => r.regionCode)
                              );
                            } else {
                              // Convert regionCode strings to full region objects
                              const selectedRegionObjects = value.map(regionCode =>
                                displayRegionValues.find(r => r.regionCode === regionCode)
                              ).filter(Boolean);
                              setSelectedRegions(selectedRegionObjects);
                              setSearchValue(value);
                            }
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return <span style={{ color: "#999" }}>Select Region</span>;
                            }
                            if (selected.length === displayRegionValues.length) {
                              return "All";
                            }
                            if (selected.length === 1) {
                              return selected[0] || "";
                            }
                            return "Multiple selection";
                          }}
                          style={{
                            height: "40px",
                            minHeight: "40px",
                            maxHeight: "40px",
                            width: "100%",
                            overflow: "hidden",
                          }}
                          IconComponent={() => (
                            <ArrowDropDownIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "6px",
                                pointerEvents: "none",
                                color: "rgba(0, 0, 0)"
                              }}
                            />
                          )}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 300,
                                overflowY: 'auto',
                              },
                            },
                          }}
                        >
                          <MenuItem value="All">
                            <Checkbox
                              checked={selectedRegions.length === displayRegionValues.length && displayRegionValues.length > 0}
                            />
                            <ListItemText primary="All" />
                          </MenuItem>
                          {displayRegionValues.map((option) => (
                            <MenuItem key={option.regionCode} value={option.regionCode}>
                              <Checkbox
                                checked={selectedRegions.some(r => r.regionCode === option.regionCode)}
                              />
                              <ListItemText primary={option.regionCode} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Box
                        style={{
                          position: "absolute",
                          right: "-1px",
                          top: "0px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          pointerEvents: "none",
                          zIndex: 1
                        }}
                      >
                        <Box style={{ pointerEvents: "auto" }}>
                          {selectedRegions.length > 0 && (
                            <Tooltip title="Clear selection" aria-label="clear">
                              <Clear
                                fontSize="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedRegions([]);
                                  setSearchValue([]);
                                  setSearchField("all");

                                  // Make API call to refresh data
                                  setCurrentPage(1);
                                  dispatch({
                                    type: FETCH_PURCHASE_ORDER_LOADING,
                                    payload: true,
                                  });
                                  dispatch(
                                    fetchPurchaseOrdersNew({
                                      searchField: "all",
                                      searchValue: null,
                                      noOfDaysAgo: parseInt(filterByDate),
                                      collaboratorTypeID: tokenData.collaborator_type_id,
                                      scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
                                      scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
                                      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                      plantCodeList: selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
                                      vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : (userAssociationData?.data?.associatedCMOList || []),
                                      pageNumber: 1,
                                      pageSize: rowsPerPage,
                                      plannerSaasUserIDs: selectedPlannerList,
                                      brand: selectedBrandList,
                                      aslNumberList: selectedMFGPlantList,
                                      poStatusIDList: null,
                                      regionCodes: null,
                                    }, 'withoutQuickSummary')
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  color: "dimgray",
                                }}
                              />
                            </Tooltip>
                          )}
                        </Box>
                        <Box style={{ pointerEvents: "auto" }}>
                          <IconButton
                            size="small"
                            style={{
                              backgroundColor: "#EB5E28",
                              color: "white",
                              borderRadius: "4px",
                              minWidth: "32px",
                              height: "40px",
                              padding: "8px",
                              borderTopRightRadius: "7px",
                              borderBottomRightRadius: "7px",
                              borderTopLeftRadius: "0px",
                              borderBottomLeftRadius: "0px",
                              margin: "0px",
                            }}
                            disabled={selectedRegions.length === 0}
                            onClick={handleSearchClick}
                          >
                            <SearchIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {searchField === "Market" && (
                    <Box style={{ position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
                      <FormControl
                        fullWidth
                        style={{
                          width: "100%",
                          height: "40px",
                          minHeight: "40px",
                          maxHeight: "40px",
                          border: "1px solid black",
                          borderTopRightRadius: "8px",
                          borderBottomRightRadius: "8px",
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                          overflow: "hidden",
                        }}
                      >
                        <Select
                          multiple
                          fullWidth
                          variant="outlined"
                          disableUnderline
                          value={selectedMarkets.map(m => m.market_group)}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.includes("All")) {
                              // Toggle select all / unselect all
                              setSelectedMarkets(
                                selectedMarkets.length === displayMarketValues.length ? [] : displayMarketValues
                              );
                              setSearchValue(
                                selectedMarkets.length === displayMarketValues.length ? [] : displayMarketValues.map(m => m.market_group)
                              );
                            } else {
                              // Convert market_group strings to full market objects
                              const selectedMarketObjects = value.map(marketGroup =>
                                displayMarketValues.find(m => m.market_group === marketGroup)
                              ).filter(Boolean);
                              setSelectedMarkets(selectedMarketObjects);
                              setSearchValue(value);
                            }
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return <span style={{ color: "#999" }}>Select Market</span>;
                            }
                            if (selected.length === displayMarketValues.length) {
                              return "All";
                            }
                            if (selected.length === 1) {
                              return selected[0] || "";
                            }
                            return "Multiple selection";
                          }}
                          style={{
                            height: "40px",
                            minHeight: "40px",
                            maxHeight: "40px",
                            // padding: "8px 14px",
                            // paddingRight: "100px",
                            width: "100%",
                            overflow: "hidden",
                          }}
                          IconComponent={() => (
                            <ArrowDropDownIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "6px",
                                pointerEvents: "none",
                                color: "rgba(0, 0, 0)"
                              }}
                            />
                          )}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 300,
                                overflowY: 'auto',
                              },
                            },
                          }}
                        >
                          <MenuItem value="All">
                            <Checkbox
                              checked={selectedMarkets.length === displayMarketValues.length && displayMarketValues.length > 0}
                            />
                            <ListItemText primary="All" />
                          </MenuItem>
                          {displayMarketValues.map((option) => (
                            <MenuItem key={option.market_group} value={option.market_group}>
                              <Checkbox
                                checked={selectedMarkets.some(m => m.market_group === option.market_group)}
                              />
                              <ListItemText primary={option.market_group} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Box
                        style={{
                          position: "absolute",
                          right: "-1px",
                          top: "0px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          pointerEvents: "none",
                          zIndex: 1
                        }}
                      >
                        <Box style={{ pointerEvents: "auto" }}>
                          {selectedMarkets.length > 0 && (
                            <Tooltip title="Clear selection" aria-label="clear">
                              <Clear
                                fontSize="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedMarkets([]);
                                  setSearchValue([]);
                                  setSearchField("all");

                                  // Make API call to refresh data
                                  setCurrentPage(1);
                                  dispatch({
                                    type: FETCH_PURCHASE_ORDER_LOADING,
                                    payload: true,
                                  });
                                  dispatch(
                                    fetchPurchaseOrdersNew({
                                      searchField: "all",
                                      searchValue: null,
                                      noOfDaysAgo: parseInt(filterByDate),
                                      collaboratorTypeID: tokenData.collaborator_type_id,
                                      scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
                                      scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
                                      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                      plantCodeList: selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
                                      vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
                                      pageNumber: 1,
                                      pageSize: rowsPerPage,
                                      plannerSaasUserIDs: selectedPlannerList,
                                      aslNumberList: selectedMFGPlantList,
                                      brand: selectedBrandList,
                                      poStatusIDList: null,
                                      marketValues: null,
                                    }, 'withoutQuickSummary')
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  color: "dimgray",
                                }}
                              />
                            </Tooltip>
                          )}
                        </Box>
                        <Box style={{ pointerEvents: "auto" }}>
                          <IconButton
                            size="small"
                            style={{
                              backgroundColor: "#EB5E28",
                              color: "white",
                              borderRadius: "4px",
                              minWidth: "32px",
                              height: "40px",
                              padding: "8px",
                              borderTopRightRadius: "7px",
                              borderBottomRightRadius: "7px",
                              borderTopLeftRadius: "0px",
                              borderBottomLeftRadius: "0px",
                              margin: "0px",
                            }}
                            disabled={selectedMarkets.length === 0}
                            onClick={handleSearchClick}
                          >
                            <SearchIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {searchField === "Date of PO Creation" && (
                    <Box style={{ position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                          autoOk
                          size="small"
                          fullWidth
                          variant="inline"
                          inputVariant="outlined"
                          format="DD-MMM-YYYY"
                          value={searchValue || null}
                          onChange={(date) => {
                            setSearchValue(date);
                          }}
                          placeholder="DD-MMM-YYYY"
                          KeyboardButtonProps={{
                            style: {
                              padding: "4px",
                              marginRight: "60px",
                            }
                          }}
                          style={{
                            width: "100%",
                          }}
                          InputProps={{
                            style: {
                              height: "40px",
                              border: "1px solid black",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              borderTopLeftRadius: "0px",
                              borderBottomLeftRadius: "0px",
                              // paddingRight: "0px",
                            }
                          }}
                        />
                      </MuiPickersUtilsProvider>
                      <Box
                        style={{
                          position: "absolute",
                          right: "-1px",
                          top: "0px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          pointerEvents: "none",
                          zIndex: 1
                        }}
                      >
                        <Box style={{ pointerEvents: "auto" }}>
                          {searchValue && (
                            <Tooltip title="Clear date" aria-label="clear">
                              <Clear
                                fontSize="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSearchValue(null);
                                  setSearchField("all");
                                  setSelectedPO(null);
                                  setCurrentPage(1);

                                  // Prepare market values for API
                                  let marketValuesForAPI = null;
                                  if (searchField === "Market" && selectedMarkets.length > 0) {
                                    marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
                                  }

                                  // Prepare region codes for API
                                  let regionCodesForAPI = null;
                                  if (searchField === "Region" && selectedRegions.length > 0) {
                                    regionCodesForAPI = selectedRegions.map(region => region.regionCode);
                                  }

                                  dispatch({
                                    type: FETCH_PURCHASE_ORDER_LOADING,
                                    payload: true,
                                  });
                                  dispatch(
                                    fetchPurchaseOrdersNew({
                                      searchField: "all",
                                      searchValue: null,
                                      noOfDaysAgo: 0,
                                      collaboratorTypeID: tokenData.collaborator_type_id,
                                      scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
                                      scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
                                      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                      plantCodeList: selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
                                      vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
                                      pageNumber: 1,
                                      pageSize: rowsPerPage,
                                      plannerSaasUserIDs: selectedPlannerList,
                                      brand: selectedBrandList,
                                      aslNumberList: selectedMFGPlantList,
                                      productTypeIDs: selectedProductTypeList,
                                      poStatusIDList: null,
                                      marketValues: marketValuesForAPI,
                                      regionCodes: regionCodesForAPI,
                                    }, 'withoutQuickSummary')
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  color: "dimgray",
                                }}
                              />
                            </Tooltip>
                          )}
                        </Box>
                        <Box style={{ pointerEvents: "auto" }}>
                          <IconButton
                            size="small"
                            style={{
                              backgroundColor: "#EB5E28",
                              color: "white",
                              borderRadius: "4px",
                              minWidth: "32px",
                              height: "40px",
                              padding: "8px",
                              borderTopRightRadius: "7px",
                              borderBottomRightRadius: "7px",
                              borderTopLeftRadius: "0px",
                              borderBottomLeftRadius: "0px",
                              margin: "0px",
                            }}
                            disabled={!searchValue}
                            onClick={handleSearchClick}
                          >
                            <SearchIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {searchField === "PO Status" && (
                    <Box style={{ position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
                      <FormControl
                        fullWidth
                        style={{
                          width: "100%",
                          height: "40px",
                          minHeight: "40px",
                          maxHeight: "40px",
                          border: "1px solid black",
                          borderTopRightRadius: "8px",
                          borderBottomRightRadius: "8px",
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                          overflow: "hidden",
                        }}
                      >
                        <Select
                          multiple
                          fullWidth
                          variant="outlined"
                          disableUnderline
                          value={selectedPOStatuses}
                          onChange={(e) => {
                            let value = e.target.value;

                            // Ensure value is always an array
                            if (!Array.isArray(value)) {
                              value = value ? [value] : [];
                            }

                            setSelectedPOStatuses(value);

                            // Store selected status IDs as array
                            if (value.length > 0) {
                              const statusIds = value.map(status => status.status_id);
                              setSearchValue(statusIds);

                            } else {
                              // If all items are removed, clear searchValue completely
                              setSearchValue([]);

                            }
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected.length === 0) {
                              return <span className="text-muted" style={{ color: '#6c757d' }}>Select PO Statuses</span>;
                            } else if (selected.length === 1) {
                              return selected[0].status_name;
                            } else {
                              return "Multiple selection";
                            }
                          }}
                          style={{
                            height: "40px",
                            minHeight: "40px",
                            maxHeight: "40px",
                            padding: "8px 50px 8px 14px", // More right padding for search icon
                            width: "100%",
                            overflow: "hidden",
                          }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 300,
                                overflowY: 'auto',
                              },
                            },
                          }}
                        >
                          {poStatusArray.length > 0 ? (
                            poStatusArray.map((status) => (
                              <MenuItem key={status.status_id} value={status}>
                                <Checkbox
                                  checked={selectedPOStatuses.some(selected => selected.status_id === status.status_id)}
                                />
                                <ListItemText primary={status.status_name} />
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No PO Statuses available</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                      <Box
                        style={{
                          position: "absolute",
                          right: "-1px",
                          top: "0px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          pointerEvents: "none",
                          zIndex: 1
                        }}
                      >
                        <Box style={{ pointerEvents: "auto" }}>
                          {selectedPOStatuses.length > 0 && (
                            <Tooltip title="Clear selection" aria-label="clear">
                              <Clear
                                fontSize="small"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent event bubbling


                                  // Clear PO Status values first
                                  setSelectedPOStatuses([]);
                                  setSearchValue([]);
                                  setSelectedPO(null);
                                  setCurrentPage(1);

                                  // Defer searchField change to next tick to allow state clearing to complete
                                  // This prevents the component from unmounting before React re-renders
                                  requestAnimationFrame(() => {
                                    setSearchField("all"); // Reset to "Select Criteria"
                                  });

                                  // Call API to refresh data without PO Status filter
                                  dispatch({
                                    type: FETCH_PURCHASE_ORDER_LOADING,
                                    payload: true,
                                  });
                                  dispatch(
                                    fetchPurchaseOrdersNew({
                                      searchField: "all",
                                      searchValue: null,
                                      noOfDaysAgo: parseInt(filterByDate),
                                      collaboratorTypeID: tokenData.collaborator_type_id,
                                      scheduleLineStatusID: parseInt(scheduleAgreementStatusID),
                                      scheduleLineStatusIDList: (scheduleAgreementStatusID === 22) ? [21, 22] : null,
                                      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                      plantCodeList: selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
                                      vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
                                      pageNumber: 1,
                                      pageSize: rowsPerPage,
                                      plannerSaasUserIDs: selectedPlannerList,
                                      brand: selectedBrandList,
                                      aslNumberList: selectedMFGPlantList,
                                      poStatusIDList: null,
                                    }, 'withoutQuickSummary')
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  color: "dimgray",
                                }}
                              />
                            </Tooltip>
                          )}
                        </Box>
                        <Box style={{ pointerEvents: "auto" }}>
                          <IconButton
                            size="small"
                            style={{
                              backgroundColor: "#EB5E28",
                              color: "white",
                              borderRadius: "4px",
                              minWidth: "32px",
                              height: "40px",
                              padding: "8px",
                              borderTopRightRadius: "7px",
                              borderBottomRightRadius: "7px",
                              borderTopLeftRadius: "0px",
                              borderBottomLeftRadius: "0px",
                              margin: "0px",
                            }}
                            disabled={selectedPOStatuses.length === 0}
                            onClick={handleSearchClick}
                          >
                            <SearchIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              sm={5}
              md={5}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                justifyContent: "flex-start",
                // justifyContent: "start",
                // marginLeft: "5rem",
              }}

            >
              <Grid
                item
              //  style={{ width: "10%" }}
              >
                <Typography
                  style={{
                    fontWeight: 550,
                    whiteSpace: "nowrap",
                    marginBottom: "1rem",
                  }}
                  className="dashboard-filter-labels"
                >
                  List of actions:
                </Typography>
              </Grid>
              <Grid item style={{ width: "100%" }} className="dashboard-filter-dropdown">
                {/* <TextField
                  select
                  style={{width:"30rem"}}
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={selectedAction}
                  onChange={(e) => handleFilterAction(e.target.value)}
                >
                  {actionsList.map((action) => (
                    <MenuItem key={action} value={action}>
                      {action}
                    </MenuItem>
                  ))}
                </TextField> */}

                <Autocomplete
                  className="dashboard-select-dropdown"
                  options={actionsList}
                  value={
                    actionsList.includes(selectedAction) ? selectedAction : null
                  }
                  onChange={(e, newValue) => handleFilterAction(newValue ?? "all")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select from the list"
                      variant="outlined"
                      size="small"
                      style={{
                        // width: "30rem",
                        // minWidth:"100%"
                        width: "100%",
                      }}

                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>
            {/* </Grid> */}

            <Grid item style={{ width: "40%", marginLeft: "2rem" }}>
              <Grid
                container
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "end",
                  // alignItems:"center"
                }}
              >
                <Grid
                  item
                  style={{
                    // textDecoration: 'underline',
                    // fontStyle: 'italic',
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <Grid>
                    <Typography
                      variant="body2"
                      style={{
                        color: "gray",
                        marginRight: "8px",
                        whiteSpace: "nowrap",
                      }}
                      className="last-synced-text"
                    >
                      {`Last synced @ ${moment(new Date()).format(
                        "HH:mm:ss; DD MMMM, YYYY"
                      )}`}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography
                      variant="body2"
                      color="primary"
                      style={{
                        textDecoration: "underline",
                        fontStyle: "italic",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      className="refresh-button"
                      onClick={handleRefresh}
                    >
                      Refresh
                      <Refresh color="primary" fontSize="small" className="refresh-button" />
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    marginTop: "10px",
                    width: "100%",
                  }}
                  className="per-page-box"
                >
                  <Typography
                    style={{
                      fontWeight: "bold",
                      marginRight: "4px",
                      whiteSpace: "nowrap",
                    }}

                  >
                    PER PAGE
                  </Typography>
                  <FormControl variant="outlined" size="small">
                    <Select
                      value={rowsPerPage}
                      onChange={handleRowsPerPageChange}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <PurchaseOrderTabTable
            tableHeight={tableHeight}
            onFocusModeChange={handleTableFocusMode}
            selectedAction={selectedAction}
            selectedPO={selectedPO}
            setSelectedPO={setSelectedPO}
            fetchPurchaseOrderDataLoading={fetchPurchaseOrderDataLoading}
            rowData={
              fetchPurchaseOrderData?.poDetailsList
                ? fetchPurchaseOrderData?.poDetailsList
                : []
            }
            featuresAccess={featuresAccess}
            selectedCMOs={selectedCMOs}
            selectedBrands={selectedBrandList}
            //userAssociations={userAssociationData}
            // rowData={fetchPurchaseOrderData?.SADetails}
            handleRefresh={(val) => handleUpdateRefresh(val)}
            handleQuickSummaryRefresh={handleQuickSummaryRefresh}
            errors={purchaseOrderData}
          />

          {showPagination === true &&
            fetchPurchaseOrderDataLoading === false && (
              <Grid
                container
                alignItems="center"
                justifyContent="center"
                style={{ paddingTop: "1rem" }}
              >
                <PaginationInput
                  totalPages={
                    purchaseOrderData?.numberOfPages
                      ? purchaseOrderData?.numberOfPages
                      : 0
                  }
                  handlePageChange={handlePageChange}
                  page={currentPage}
                />
              </Grid>
            )}
        </Grid>
      </Grid>
      <Dialog open={savedSuccessfull} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={handleCloseSave}
          title={"Saved successfully"}
        />
      </Dialog>
      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>

          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default PurchaseOrderDashboard;
